import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FcCalendar } from "react-icons/fc";
import { MdAttachFile } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import { MdExpandMore } from "react-icons/md";
import { RiAddLine } from "react-icons/ri";
// import { Snackbar, Alert } from '@mui/material';
import Snackbar from "@mui/material/Snackbar";
// import Alert from '@mui/material/Alert';
import "./InsertData.css";
import "./new_InsertData.css";
import MuiAlert from "@mui/material/Alert";
import { RxCross2 } from "react-icons/rx";
import { IoMdClose } from "react-icons/io";
import enTranslations from "./translations/en.json";
import guTranslations from "./translations/gu.json";
import hinTranslations from "./translations/hi.json";
import mrTranslations from "./translations/mr.json";
import Multiselect from "multiselect-react-dropdown";
import API_URL from "./Config";
import { parseISO, format } from "date-fns";
import EntryTypeFields from "./components/common/EntryTypeFields";
import { getMasterDomainItems } from "./services/masterDataService";
import {
  buildActOptions,
  buildCasePropertyTypeOptions,
  buildStatusOptions,
  buildUnitOptions,
  buildVehicleReasonOptions,
  isOtherActOption,
  isOtherCasePropertyType,
  isVehicleCasePropertyType,
  matchOptionValue,
} from "./utils/casePropertyMasterOptions";
import {
  buildEntryTypeValidationErrors,
  DEFAULT_ENTRY_TYPE_CODE,
  DEFAULT_ENTRY_TYPE_OPTIONS,
  normalizeEntryTypeOptions,
  normalizeEntryTypeRecord,
  sanitizeRecordForEntryType,
} from "./utils/entryTypeHelpers";

const getStoredUserState = () => {
  const storedState = String(localStorage.getItem("userState") ?? "").trim();
  const normalizedState = storedState.toLowerCase();

  return normalizedState === "null" || normalizedState === "undefined"
    ? ""
    : storedState;
};

function InsertData({ togglePopup, handleInsertPopupClose, fetchUseData }) {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("FSL Port Blair");
  const [selectedCourtOrderOption, setSelectedCourtOrderOption] =
    useState("Disposed");
  const [descriptionWordCount, setDescriptionWordCount] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isNewEntryAdded, setIsNewEntryAdded] = useState(false);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  // const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // const handleDropdownChange = (event) => {
  //   const selectedValue = event.target.value;
  //   setSelectedOption(selectedValue);
  // };
  const handleDropdownChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleDropdownCourtOrderChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCourtOrderOption(selectedValue);
  };

  const [selectedDate, setSelectedDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachmentFile, setAttachmentFile] = useState(null);
  // const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userState] = useState(getStoredUserState);
  const [showSectionOfLawInput, setShowSectionOfLawInput] = useState(false);
  const [sectionOfLaw, setSectionOfLaw] = useState("");
  const [sectionDateOfHandingOver, setSectionDateOfHandingOver] = useState("");
  const [sectionExecutiveOrderNo, setSectionExecutiveOrderNo] = useState("");
  const [sectionDisposaldate, setSectionsectionDisposaldate] = useState("");
  const [sectionMemoNo, setSectionMemoNo] = useState("");
  const [sectionCourtOrderNo, setSectionCourtOrderNo] = useState("");
  const [sectionOtherStatus, setSectionOtherStatus] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [sectionReleased, setSectionReleased] = useState("");
  const [sectionRelesedDate, setSectionRelesedDate] = useState("");
  const [sectionGdNo, setSectionGdNo] = useState("");
  const [sectionAuctionDate, setSectionAuctionDate] = useState("");
  const [sectionAawarded, setSectionAawarded] = useState("");
  const [sectionAuctionMemoNo, setSectionAuctionMemoNo] = useState("");
  const [sectionAuctionOrderNo, setSectionAuctionOrderNo] = useState("");
  const [showSpecifyActInput, setShowSpecifyActInput] = useState(false);
  const [selectedAct, setSelectedAct] = useState("");
  const [specifyAct, setSpecifyAct] = useState("");
  const [userName, setUserName] = useState("");
  const [sectionCfslName, setSectionCfslName] = useState("");
  const [sectionSentBy, setSectionSentBy] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [masterActOptions, setMasterActOptions] = useState([]);
  const [masterCasePropertyTypeOptions, setMasterCasePropertyTypeOptions] =
    useState([]);
  const [masterStatusOptions, setMasterStatusOptions] = useState([]);
  const [masterUnitOptions, setMasterUnitOptions] = useState([]);
  const [masterVehicleReasonOptions, setMasterVehicleReasonOptions] = useState(
    [],
  );
  const [chargeSheetDate, setChargeSheetDate] = useState("");
  const [entryTypes, setEntryTypes] = useState(DEFAULT_ENTRY_TYPE_OPTIONS);
  const { selectedLanguage } = useContext(LanguageContext);

  const translations = {
    en: enTranslations,
    gu: guTranslations,
    hi: hinTranslations,
    mr: mrTranslations,
  };

  // const [cfslName, setCfslName] = useState('Name of CFSL');
  const [sectionOfLaws, setSectionOfLaws] = useState({});
  // const [setSelectedColor] = useState('');
  const [validationErrors, setValidationErrors] = useState({
    police_station: false,
    entry_type: false,
    guna_number: false,
    receipt_number: false,
    other_entry_type: false,
    date_of_seizure: false,
    exhibit_number: false,
    // quantity: false,
    // price: false,
    // muddamaal_type: false,
    // status_of_muddamaal: false,
    // vehicle_reason:false,
    description: false,
    price: false,
  });

  useEffect(() => {
    let isMounted = true;

    const loadMasterOptions = async () => {
      try {
        const [
          casePropertyTypeResponse,
          unitResponse,
          actResponse,
          casePropertyStatusResponse,
          vehicleReasonResponse,
        ] = await Promise.all([
          getMasterDomainItems("case_property_type", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("unit", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("act", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("case_property_status", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("vehicle_reason", {
            lang: selectedLanguage,
            state: userState,
          }),
        ]);

        if (!isMounted) {
          return;
        }

        setMasterCasePropertyTypeOptions(
          buildCasePropertyTypeOptions(casePropertyTypeResponse.items),
        );
        setMasterUnitOptions(buildUnitOptions(unitResponse.items));
        setMasterActOptions(buildActOptions(actResponse.items));
        setMasterStatusOptions(
          buildStatusOptions(casePropertyStatusResponse.items),
        );
        setMasterVehicleReasonOptions(
          buildVehicleReasonOptions(vehicleReasonResponse.items),
        );
      } catch (error) {
        console.error("Error fetching case property master options:", error);

        if (!isMounted) {
          return;
        }

        setMasterCasePropertyTypeOptions([]);
        setMasterUnitOptions([]);
        setMasterActOptions([]);
        setMasterStatusOptions([]);
        setMasterVehicleReasonOptions([]);
      }
    };

    loadMasterOptions();

    return () => {
      isMounted = false;
    };
  }, [selectedLanguage, userState]);

  useEffect(() => {
    if (masterStatusOptions.length === 0) {
      return;
    }

    setEntries((prevEntries) =>
      prevEntries.map((entry) => {
        const matchedStatusValue = matchOptionValue(
          masterStatusOptions,
          entry.status_of_muddamaal,
        );

        if (matchedStatusValue) {
          return entry;
        }

        return {
          ...entry,
          status_of_muddamaal: masterStatusOptions[0].value,
        };
      }),
    );
  }, [masterStatusOptions]);

  useEffect(() => {
    if (masterCasePropertyTypeOptions.length === 0) {
      return;
    }

    setEntries((prevEntries) =>
      prevEntries.map((entry) => {
        const matchedCasePropertyType = matchOptionValue(
          masterCasePropertyTypeOptions,
          entry.muddamaal_type,
        );
        const nextCasePropertyType =
          matchedCasePropertyType ||
          masterCasePropertyTypeOptions[0]?.value ||
          "";
        const isVehicleType = isVehicleCasePropertyType(
          nextCasePropertyType,
          masterCasePropertyTypeOptions,
        );
        const matchedVehicleReason = matchOptionValue(
          masterVehicleReasonOptions,
          entry.vehicle_reason,
        );

        return {
          ...entry,
          muddamaal_type: nextCasePropertyType,
          vehicle_reason: isVehicleType
            ? matchedVehicleReason || masterVehicleReasonOptions[0]?.value || ""
            : "",
        };
      }),
    );
  }, [masterCasePropertyTypeOptions, masterVehicleReasonOptions]);

  // const handleGunaNumberChange = (e, index) => {
  //   let value = e.target.value;

  //   // Remove any characters that are not digits
  //   value = value.replace(/[^0-9]/g, "");

  //   // Apply the formatting for xxx/yyy/zz
  //   if (value.length > 3 && value.length <= 6) {
  //     value = `${value.slice(0, 3)}/${value.slice(3)}`;
  //   } else if (value.length > 6) {
  //     value = `${value.slice(0, 3)}/${value.slice(3, 6)}/${value.slice(6, 8)}`;
  //   }

  //   // Update the state with the formatted value
  //   const updatedEntries = [...entries];
  //   updatedEntries[index].guna_number = value;
  //   setEntries(updatedEntries);
  // };

  // const handleGunaNumberChange = (e, index) => {
  //   let value = e.target.value;
  //   let validationError = false;

  //   // Remove any characters that are not alphanumeric
  //   value = value.replace(/[^a-zA-Z0-9]/g, "");

  //   // Apply the formatting for xxx/yyy/zz
  //   if (value.length > 3 && value.length <= 6) {
  //     value = `${value.slice(0, 3)}/${value.slice(3)}`;
  //   } else if (value.length > 6) {
  //     value = `${value.slice(0, 3)}/${value.slice(3, 6)}/${value.slice(6, 8)}`;
  //   }

  //   // Update the state with the formatted value
  //   const updatedEntries = [...entries];
  //   updatedEntries[index].guna_number = value;
  //   setEntries(updatedEntries);

  // };
  const updateEntryTypeFieldErrors = (fieldName) => {
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      entry_type: fieldName === "entry_type" ? false : prevErrors.entry_type,
      guna_number: fieldName === "guna_number" ? false : prevErrors.guna_number,
      receipt_number:
        fieldName === "receipt_number" ? false : prevErrors.receipt_number,
      other_entry_type:
        fieldName === "other_entry_type" ? false : prevErrors.other_entry_type,
    }));
  };

  const updateSharedEntryIdentifier = (index, updater) => {
    setEntries((prevEntries) =>
      prevEntries.map((entry, entryIndex) => {
        const shouldSync =
          entryIndex === index || (index === 0 && prevEntries.length > 1);

        return shouldSync ? updater(entry) : entry;
      }),
    );
  };

  const handleEntryTypeChange = (entryTypeCode, index) => {
    updateSharedEntryIdentifier(index, (entry) =>
      sanitizeRecordForEntryType(
        {
          ...normalizeEntryTypeRecord(entry, entryTypes),
          entry_type: entryTypeCode,
        },
        entryTypes,
      ),
    );
    updateEntryTypeFieldErrors("entry_type");
    updateEntryTypeFieldErrors("guna_number");
    updateEntryTypeFieldErrors("receipt_number");
    updateEntryTypeFieldErrors("other_entry_type");
  };

  const handleEntryTypeFieldChange = (fieldName, value, index) => {
    updateSharedEntryIdentifier(index, (entry) => ({
      ...entry,
      [fieldName]: value,
    }));
    updateEntryTypeFieldErrors(fieldName);
  };

  const handleSubEntry = () => {
    if (entries.length > 1) {
      setEntries((prevEntries) => prevEntries.slice(0, -1));
    } else {
      alert("Cannot remove the last form entry!");
    }
  };

  const translatedText = (key) => translations[selectedLanguage][key] || key;
  const activeCasePropertyTypeOptions = masterCasePropertyTypeOptions;
  // const handleCfslNameChange = (e) => {
  //   setCfslName(e.target.value);
  // };
  const [entries, setEntries] = useState([
    {
      police_station: "",
      entry_type: DEFAULT_ENTRY_TYPE_CODE,
      guna_number: "",
      receipt_number: "",
      other_entry_type: "",
      date_of_seizure: null,
      chart_sheet_date: null, // Ensure this is null or a valid Date object
      next_court_date: null,
      exhibit_number: "",
      quantity: "",
      price: "",
      other_case_property_name: "",
      unit: "",
      muddamaal_type: translatedText("drugs_narcotics"),
      vehicle_reason: translatedText("detained"),
      status_of_muddamaal: translatedText("police_station_account"),
      description: "",
      status_details: {
        name: "",
        date: "",
        order_no: "",
        javak_no: "",
      },
    },
  ]);

  const handleDeleteFile = (indexToDelete) => {
    setSelectedFiles(
      selectedFiles.filter((_, index) => index !== indexToDelete),
    );
  };

  const fileInputRef = useRef(null);

  const handleUploadButtonClick = () => {
    // Trigger click event of file input when upload button is clicked
    fileInputRef.current.click();
  };

  const handleIconClick = () => {
    // Show selected files when icon is clicked
    setIsPopupOpen(true);
  };

  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  const handleStatusDetailsChange = (e, entryIndex, field) => {
    const { value } = e.target;

    setEntries((prevEntries) => {
      const updatedEntries = [...prevEntries];
      const currentEntry = updatedEntries[entryIndex];

      currentEntry.status_details = currentEntry.status_details || {};

      currentEntry.status_details["status_of_muddamaal"] =
        currentEntry.status_of_muddamaal;

      if (
        translatedText("police_station_account") ===
          currentEntry.status_of_muddamaal ||
        translatedText("comes_from_fsl") === currentEntry.status_of_muddamaal ||
        translatedText("comes_from_court") ===
          currentEntry.status_of_muddamaal ||
        translatedText("comes_from_bank") ===
          currentEntry.status_of_muddamaal ||
        translatedText("sent_to_ps_ccs") === currentEntry.status_of_muddamaal ||
        translatedText("central_cold_storage") ===
          currentEntry.status_of_muddamaal
      ) {
        currentEntry.status_details[field] = value;
      } else if (
        translatedText("returned") === currentEntry.status_of_muddamaal ||
        translatedText("released_in_fsl") ===
          currentEntry.status_of_muddamaal ||
        translatedText("pending_in_court") ===
          currentEntry.status_of_muddamaal ||
        translatedText("deposited_in_bank") ===
          currentEntry.status_of_muddamaal ||
        translatedText("sent_to_ps_ccs") === currentEntry.status_of_muddamaal ||
        translatedText("central_cold_storage") ===
          currentEntry.status_of_muddamaal
      ) {
        if (field === "name" || field === "date") {
          currentEntry.status_details[field] = value;
        } else if (field === "javak_no") {
          currentEntry.status_details[field] = value;
        }
      }

      return updatedEntries;
    });
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    let validationError = false;

    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        [name]: value,
        status_details: { ...newEntries[index].status_details },
      };

      if (name === "description") {
        setDescriptionWordCount(value.trim().split(/\s+/).length);
      }

      if (name === "selectedLanguage") {
        const translatedMuddamaalOptions =
          translations[value].muddamaal_type_options || [];
        const translatedMuddamaalOptionsm =
          translations[value].muddamaal_type_options_m || [];
        const translatedVehicleReasonOptions =
          translations[value].vehicle_reason_options || [];
        const translatedMuddamaalStatusOptions =
          translations[value].status_of_muddamaal_options || [];
        newEntries[index] = {
          ...newEntries[index],
          muddamaal_type: translatedMuddamaalOptions[0] || "અન્ય",
          muddamaal_types: translatedMuddamaalOptionsm[0] || "અન્ય",
          vehicle_reason: translatedVehicleReasonOptions[0] || "ડીટેઇન્ડ",
          muddamaal_status: translatedMuddamaalStatusOptions[0],
        };
      }

      if (name === "muddamaal_type") {
        newEntries[index] = {
          ...newEntries[index],
          vehicle_reason: value === "વાહન" ? "ડીટેઇન્ડ" : "",
        };
      }

      if (name === "selectedLanguage") {
        newEntries[index] = {
          ...newEntries[index],
          muddamaal_type:
            masterCasePropertyTypeOptions[0]?.value ||
            newEntries[index].muddamaal_type,
          muddamaal_types:
            masterCasePropertyTypeOptions[0]?.value ||
            newEntries[index].muddamaal_type,
          vehicle_reason:
            masterVehicleReasonOptions[0]?.value ||
            newEntries[index].vehicle_reason,
          muddamaal_status:
            masterStatusOptions[0]?.value ||
            newEntries[index].status_of_muddamaal,
        };
      }

      if (name === "muddamaal_type") {
        const isVehicleType = isVehicleCasePropertyType(
          value,
          masterCasePropertyTypeOptions,
        );

        newEntries[index] = {
          ...newEntries[index],
          vehicle_reason: isVehicleType
            ? matchOptionValue(
                masterVehicleReasonOptions,
                newEntries[index].vehicle_reason,
              ) ||
              masterVehicleReasonOptions[0]?.value ||
              ""
            : "",
        };
      }

      // Handling additional fields related to status_details
      if (
        name.includes("NameStatus1") ||
        name.includes("DateStatus1") ||
        name.includes("OrderStatus")
      ) {
        const statusIndex = 0;
        newEntries[index].status_details = {
          ...newEntries[index].status_details,
          [name.replace("Status1", "")]: value,
        };
      } else if (
        name.includes("NameStatus2") ||
        name.includes("DateStatus2") ||
        name.includes("SendStatus")
      ) {
        const statusIndex = 1;
        newEntries[index].status_details = {
          ...newEntries[index].status_details,
          [name.replace("Status2", "")]: value,
        };
      }

      return newEntries;
    });

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationError,
    }));
  };

  useEffect(() => {
    // Retrieve the user's name from local storage
    const name = localStorage.getItem("userName");

    if (name) {
      setUserName(name);
      setEntries((prevFormData) => [
        {
          ...prevFormData[0],
          police_station: name,
        },
      ]);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchEntryTypes = async () => {
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/entry_types`, {
          headers: {
            Authorization: authKey,
          },
        });

        if (!isMounted) {
          return;
        }

        const normalizedEntryTypes = normalizeEntryTypeOptions(response.data);
        setEntryTypes(normalizedEntryTypes);
        setEntries((prevEntries) =>
          prevEntries.map((entry) =>
            normalizeEntryTypeRecord(entry, normalizedEntryTypes),
          ),
        );
      } catch (error) {
        console.error("Error fetching entry types:", error);
      }
    };

    fetchEntryTypes();

    return () => {
      isMounted = false;
    };
  }, []);

  // useEffect(() => {
  //   const fetchOptions = async () => {
  //     const authKey = localStorage.getItem("authKey");

  //     try {
  //       // Fetch data from API with authorization
  //       const response = await axios.get('http://127.0.0.1:5000/api/get_acts', {
  //         headers: {
  //           Authorization: authKey,
  //         },
  //       });

  //       // Debugging: Log the full response to understand the structure
  //       console.log('Full API Response:', response);

  //       // Assuming response.data is the array we need
  //       if (Array.isArray(response.data)) {
  //         console.log('Fetched acts:', response.data); // Should log the array of acts
  //         setOptions(response.data); // Set the options directly
  //       } else {
  //         console.error('Failed to fetch options. Response data:', response.data);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching options:', error);
  //     }
  //   };

  //   fetchOptions();
  // }, []);

  // const handleSelect = (selectedList, selectedItem) => {
  //   setSelectedOptions(selectedList);
  // };

  // const handleRemove = (selectedList, removedItem) => {
  //   setSelectedOptions(selectedList);
  // };

  // const [options] = useState([
  //   translatedText("Acts")
  // ]);

  const filteredOptions = masterActOptions;
  const otherActOption = selectedOptions.find((option) =>
    isOtherActOption(option),
  );
  const otherActOptionName = otherActOption?.name || "Others Acts";
  const getSectionOfLawValue = (optionName, { isOther = false } = {}) =>
    isOther
      ? sectionOfLaws[optionName] || sectionOfLaws["Others Acts"] || ""
      : sectionOfLaws[optionName] || "";

  //   const excludedActsForStates = [17, 18, 19, 20, 21, 22, 23, 24, 25, 26];

  // const filteredOptions = acts.filter((act) => {
  //   // Exclude specific acts for Goa, Gujarat, or Andaman and Nicobar when the language is Marathi
  //   if (
  //     (userState === "Goa" || userState === "Gujarat" || userState === "Andaman and Nicobar") &&
  //     selectedLanguage === "Marathi" &&
  //     excludedActsForStates.includes(act.id)
  //   ) {
  //     return false; // Exclude the act
  //   }
  //   return true; // Include all other acts
  // });

  // const handleSelect = (selectedList) => {
  //   const selectedLawNames = selectedList.map((law) => law.name).join(", ");
  //   setSelectedOptions(selectedList);
  //   setShowSpecifyActInput(
  //     selectedList.some((option) => option.name === "Others Acts")
  //   );
  //   setShowSectionOfLawInput(
  //     !selectedList.some((option) => option.name === "Others Acts")
  //   );
  //   setSelectedAct(selectedLawNames);
  // };
  const handleSelect = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => isOtherActOption(option)),
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => isOtherActOption(option)),
    );
    setSelectedAct(selectedLawNames);

    // Clear the validation error for selectedAct if an option is selected
    if (selectedList.length > 0) {
      const updatedValidationErrors = { ...validationErrors };
      updatedValidationErrors.selectedAct = false;
      setValidationErrors(updatedValidationErrors);
    }
  };

  const handleRemove = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => isOtherActOption(option)),
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => isOtherActOption(option)),
    );
    setSelectedAct(selectedLawNames);
  };

  const handleDateChange = (date, index) => {
    setSelectedDate(date);

    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        date_of_seizure: date,
      };
      return newEntries;
    });

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      date_of_seizure: false,
    }));
  };

  // const handleChargeSheetDateChange = (date, index) => {
  //   setSelectedDate(date);

  //   setEntries((prevEntries) => {
  //     const newEntries = [...prevEntries];
  //     newEntries[index] = {
  //       ...newEntries[index],
  //       chart_sheet_date: date, // Update only the charge_sheet_date field
  //     };
  //     return newEntries;
  //   });

  // };

  // const handleNextCourtDate = (date, index) => {
  //   setSelectedDate(date);
  //   setEntries((prevEntries) => {
  //     const newEntries = [...prevEntries];
  //     newEntries[index] = {
  //       ...newEntries[index],
  //       next_court_date: date, // Update `next_court_date` instead of `charge_sheet_date`
  //     };
  //     return newEntries;
  //   });

  // };

  const handleChargeSheetDateChange = (date, index) => {
    if (!date) return; // Handle case when the date is cleared

    const selectedDate = new Date(date);
    selectedDate.setHours(12, 0, 0, 0); // Ensure a consistent time to avoid timezone shifts

    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        chart_sheet_date: selectedDate, // Store the date object with fixed time
      };
      return newEntries;
    });

    console.log("Selected Chart Sheet Date:", selectedDate);
  };

  const handleNextCourtDate = (date, index) => {
    if (!date) return; // Handle case when the date is cleared

    const selectedDate = new Date(date);
    selectedDate.setHours(12, 0, 0, 0); // Ensure a consistent time to avoid timezone shifts

    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        next_court_date: selectedDate, // Store the date object with fixed time
      };
      return newEntries;
    });

    console.log("Selected Next Court Date:", selectedDate);
  };

  const handleSectionOfLawChange = (e, optionName) => {
    setSectionOfLaws({
      ...sectionOfLaws,
      [optionName]: e.target.value,
    });
  };

  const handleDateIconClick = (index) => {
    document.getElementById(`date_of_seizure_${index}`).click();
  };

  const handleAddEntry = () => {
    setIsNewEntryAdded(true);

    // Use values from the last entry for the specified fields
    const lastEntry = entries[entries.length - 1] || {};
    const newEntry = {
      entry_type: lastEntry.entry_type || DEFAULT_ENTRY_TYPE_CODE,
      guna_number: lastEntry.guna_number || "",
      receipt_number: lastEntry.receipt_number || "",
      other_entry_type: lastEntry.other_entry_type || "",
      quantity: "",
      price: "",
      unit: "",
      dropDownList: "FSL Port Blair",
      muddamaal_type:
        masterCasePropertyTypeOptions[0]?.value ||
        lastEntry.muddamaal_type ||
        "",
      vehicle_reason: isVehicleCasePropertyType(
        masterCasePropertyTypeOptions[0]?.value ||
          lastEntry.muddamaal_type ||
          "",
        masterCasePropertyTypeOptions,
      )
        ? masterVehicleReasonOptions[0]?.value || lastEntry.vehicle_reason || ""
        : "",
      other_case_property_name: "",
      status_of_muddamaal:
        lastEntry.status_of_muddamaal ||
        translatedText("police_station_account"),
      description: "",
      courtOrderNo: "",
      releasedToWhom: "",
      releseddate: "",
      gdNo: "",
      police_station: lastEntry.police_station || "",
      date_of_seizure: lastEntry.date_of_seizure || null,
      exhibit_number: lastEntry.exhibit_number || "",
      status_details: {
        name: lastEntry.status_details?.name || "",
        date: lastEntry.status_details?.date || "",
        order_no: lastEntry.status_details?.order_no || "",
        javak_no: lastEntry.status_details?.javak_no || "",
        cfslName: lastEntry.status_details?.cfslName || "",
        disposalOnCourt: lastEntry.status_details?.disposalOnCourt || "",
        fslList: lastEntry.status_details?.fslList || "",
        paymentMode: lastEntry.status_details?.paymentMode || "",
        handoverMemoNo: lastEntry.status_details?.handoverMemoNo || "",
        dateOfHandingOver: lastEntry.status_details?.dateOfHandingOver || "",
        courtOrderNo: lastEntry.status_details?.courtOrderNo || "",
        releasedToWhom: lastEntry.status_details?.releasedToWhom || "",
        releseddate: lastEntry.status_details?.releseddate || "",
        gdNo: lastEntry.status_details?.gdNo || "",
        executiveOrder: lastEntry.status_details?.executiveOrder || "",
        disposalDate: lastEntry.status_details?.disposalDate || "",
        auctionDate: lastEntry.status_details?.auctionDate || "",
        auctionOrderNo: lastEntry.status_details?.auctionOrderNo || "",
        awarded: lastEntry.status_details?.awarded || "",
        auctionMemoNo: lastEntry.status_details?.auctionMemoNo || "",
      },
    };

    // Set additional properties based on the selected options
    newEntry.selectedAct = selectedAct;
    newEntry.specifyAct = specifyAct;
    newEntry.sectionOfLaws = {};
    selectedOptions.forEach((option) => {
      newEntry.sectionOfLaws[option.name] = sectionOfLaws[option.name] || "";
    });
    newEntry.sectionMemoNo = sectionMemoNo;
    newEntry.status_details.cfslName = sectionCfslName;
    newEntry.status_details.disposalOnCourt = selectedCourtOrderOption;
    newEntry.status_details.fslList = selectedOption;
    newEntry.status_details.paymentMode = selectedPaymentMethod;
    newEntry.status_details.handoverMemoNo = sectionMemoNo;

    // Apply conditions based on the status_of_muddamaal
    if (
      translatedText("handed_over_to_other_department") ===
      newEntry.status_of_muddamaal
    ) {
      newEntry.status_details.handoverMemoNo = sectionMemoNo;
      newEntry.status_details.dateOfHandingOver = sectionDateOfHandingOver;
    }
    if (
      translatedText("release_on_court_order") === newEntry.status_of_muddamaal
    ) {
      newEntry.status_details.courtOrderNo = sectionCourtOrderNo;
      newEntry.status_details.releasedToWhom = sectionReleased;
      newEntry.status_details.releseddate = sectionRelesedDate;
      newEntry.status_details.gdNo = sectionGdNo;
    }
    if (translatedText("destroyed_disposed") === newEntry.status_of_muddamaal) {
      newEntry.status_details.executiveOrder = sectionExecutiveOrderNo;
      newEntry.status_details.disposalDate = sectionDisposaldate;
      newEntry.status_details.auctionDate = sectionAuctionDate;
      newEntry.status_details.auctionOrderNo = sectionAuctionOrderNo;
      newEntry.status_details.awarded = sectionAawarded;
      newEntry.status_details.auctionMemoNo = sectionAuctionMemoNo;
    }

    // Add the new entry to the entries state
    setEntries((prevEntries) => [...prevEntries, newEntry]);
  };

  const handleFileInputChange = (e, documentType) => {
    const files = e.target.files;
    const newFileDetails = Array.from(files).map((file) => ({
      name: file.name,
      size: file.size,
      type: documentType,
    }));

    setSelectedFiles([...selectedFiles, ...newFileDetails]);

    setAttachmentFile((prevFiles) => [
      ...(prevFiles || []),
      ...Array.from(files).map((file) => ({ file, type: documentType })),
    ]);
  };

  const handleDisposalFileInputChange = (e) =>
    handleFileInputChange(e, "disposal");
  const handleAuctionFileInputChange = (e) =>
    handleFileInputChange(e, "auction");
  const handleHandedOverFileInputChange = (e) =>
    handleFileInputChange(e, "handedOver");
  const handleCourtOrderFileInputChange = (e) =>
    handleFileInputChange(e, "courtOrder");

  const handleUnitChange = (event) => {
    setSelectedUnit(event.target.value);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  // const handleSubmit = async (e, index) => {
  //   e.preventDefault();
  //   let hasErrors = false;
  //   setIsSubmitting(true);

  //   // Validate form fields
  //   const updatedValidationErrors = {
  //     police_station: !entries[index].police_station,
  //     guna_number: !entries[index].guna_number,
  //     date_of_seizure: !entries[index].date_of_seizure,
  //     exhibit_number: !entries[index].exhibit_number,
  //     description: !entries[index].description,
  //     selectedAct: selectedOptions.length === 0,
  //     specifyAct:
  //       selectedOptions.some((option) => option.name === "Others Acts") &&
  //       !specifyAct.trim(),
  //     sectionOfLaws: selectedOptions.some(
  //       (option) => !sectionOfLaws[option.name]?.trim()
  //     ),
  //   };

  //   setValidationErrors(updatedValidationErrors);

  //   // Check if there are any validation errors
  //   for (const field in updatedValidationErrors) {
  //     if (updatedValidationErrors[field]) {
  //       hasErrors = true;
  //     }
  //   }

  //   if (hasErrors) {
  //     setIsSubmitting(false);
  //     setSnackbarMessage("Please fill in all required fields.");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   let selectedAct = "";
  //   if (selectedOptions.some((option) => option.name === "Others Acts")) {
  //     selectedAct = specifyAct.trim();
  //   } else {
  //     selectedAct = selectedOptions.map((option) => option.name).join(", ");
  //   }

  //   try {
  //     setIsSubmitting(true);

  //     const authKey = localStorage.getItem("authKey");
  //     const entryData = [...entries];

  //     entryData.forEach((entry, entryIndex) => {
  //       entry.status_details = entry.status_details || {};
  //       entry.selectedAct = selectedAct;
  //       entry.specifyAct = specifyAct;
  //       entry.unit = selectedUnit;
  //       selectedOptions.forEach((option) => {
  //         entry.sectionOfLaws = {
  //           ...entry.sectionOfLaws,
  //           [option.name]: sectionOfLaws[option.name] || "",
  //         };
  //       });
  //       entry.sectionMemoNo = sectionMemoNo;
  //       entry.status_details.cfslName = sectionCfslName;
  //       entry.status_details.sentBy = sectionSentBy;
  //       entry.status_details.other_status_case_property = sectionOtherStatus;
  //       entry.status_details.disposalOnCourt = selectedCourtOrderOption;
  //       entry.status_details.fslList = selectedOption;
  //       entry.status_details.paymentMode = selectedPaymentMethod;
  //       if (
  //         translatedText("handed_over_to_other_department") ===
  //         entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.handoverMemoNo = sectionMemoNo;
  //         entry.status_details.dateOfHandingOver = sectionDateOfHandingOver;
  //       }
  //       if (
  //         translatedText("release_on_court_order") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.courtOrderNo = sectionCourtOrderNo;
  //         entry.status_details.releasedToWhom = sectionReleased;
  //         entry.status_details.releseddate = sectionRelesedDate;
  //         entry.status_details.gdNo = sectionGdNo;
  //       }
  //       if (
  //         translatedText("destroyed_disposed") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.executiveOrder = sectionExecutiveOrderNo;
  //         entry.status_details.disposalDate = sectionDisposaldate;
  //         entry.status_details.auctionDate = sectionAuctionDate;
  //         entry.status_details.auctionOrderNo = sectionAuctionOrderNo;
  //         entry.status_details.awarded = sectionAawarded;
  //         entry.status_details.auctionMemoNo = sectionAuctionMemoNo;
  //       }
  //     });

  //     // Create FormData object and append entries and files
  //     const requestBody = new FormData();
  //     requestBody.append("entryData", JSON.stringify(entryData));

  //     if (attachmentFile && attachmentFile.length > 0) {
  //       for (const { file, type } of attachmentFile) {
  //         console.log(
  //           "Appending file:",
  //           file.name,
  //           "Size:",
  //           file.size,
  //           "Type:",
  //           type
  //         );
  //         requestBody.append("Attachment", file);
  //         requestBody.append("FileSize", file.size);
  //         requestBody.append("DocumentType", type);
  //       }
  //     }

  //     const response = await axios.post(`${API_URL}/api/data`, requestBody, {
  //       headers: {
  //         Authorization: authKey,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     const updatedData = [response.data];
  //     const formattedData = updatedData.map((entry) => ({
  //       ...entry,
  //       status_details: JSON.parse(entry.status_details || "{}"),
  //     }));

  //     setSnackbarMessage("Data inserted successfully!");
  //     setOpenSnackbar(true);
  //     await fetchUseData();

  //     setTimeout(() => {
  //       setOpenSnackbar(false);
  //       handleInsertPopupClose();
  //     }, 1000);
  //   } catch (error) {
  //     console.error(error);
  //     if (error.response && error.response.status === 401) {
  //       navigate("/signin");
  //     }
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  // const handleSubmit = async (e, index) => {
  //   e.preventDefault();
  //   let hasErrors = false;
  //   setIsSubmitting(true);

  //   // Validate form fields
  //   const updatedValidationErrors = {
  //     police_station: !entries[index].police_station,
  //     guna_number: !entries[index].guna_number,
  //     date_of_seizure: !entries[index].date_of_seizure,
  //     exhibit_number: !entries[index].exhibit_number,
  //     description: !entries[index].description,
  //     selectedAct: selectedOptions.length === 0,
  //     specifyAct:
  //       selectedOptions.some((option) => option.name === "Others Acts") &&
  //       !specifyAct.trim(),
  //     sectionOfLaws: selectedOptions.some(
  //       (option) => !sectionOfLaws[option.name]?.trim()
  //     ),
  //   };

  //   setValidationErrors(updatedValidationErrors);

  //   // Check if there are any validation errors
  //   for (const field in updatedValidationErrors) {
  //     if (updatedValidationErrors[field]) {
  //       hasErrors = true;
  //     }
  //   }

  //   if (hasErrors) {
  //     setIsSubmitting(false);
  //     setSnackbarMessage("Please fill in all required fields.");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   let selectedAct = "";
  //   if (selectedOptions.some((option) => option.name === "Others Acts")) {
  //     selectedAct = specifyAct.trim();
  //   } else {
  //     selectedAct = selectedOptions.map((option) => option.name).join(", ");
  //   }

  //   try {
  //     setIsSubmitting(true);

  //     const authKey = localStorage.getItem("authKey");
  //     const entryData = [...entries];

  //     entryData.forEach((entry, entryIndex) => {
  //       // Strip the time part of the date fields
  //       // entry.chart_sheet_date = entry.charge_sheet_date
  //       //   ? new Date(entry.charge_sheet_date).toISOString().split("T")[0] // Get date in yyyy-MM-dd format
  //       //   : null;
  //       // entry.next_court_date = entry.next_court_date
  //       //   ? new Date(entry.next_court_date).toISOString().split("T")[0] // Get date in yyyy-MM-dd format
  //       //   : null;
  //       entry.chart_sheet_date = entry.chart_sheet_date || {};
  //       entry.next_court_date = entry.next_court_date || {};
  //       entry.status_details = entry.status_details || {};
  //       entry.selectedAct = selectedAct;
  //       entry.specifyAct = specifyAct;
  //       entry.unit = selectedUnit;
  //       selectedOptions.forEach((option) => {
  //         entry.sectionOfLaws = {
  //           ...entry.sectionOfLaws,
  //           [option.name]: sectionOfLaws[option.name] || "",
  //         };
  //       });
  //       entry.sectionMemoNo = sectionMemoNo;
  //       entry.status_details.cfslName = sectionCfslName;
  //       entry.status_details.sentBy = sectionSentBy;
  //       entry.status_details.other_status_case_property = sectionOtherStatus;
  //       entry.status_details.disposalOnCourt = selectedCourtOrderOption;
  //       entry.status_details.fslList = selectedOption;
  //       entry.status_details.paymentMode = selectedPaymentMethod;
  //       if (
  //         translatedText("handed_over_to_other_department") ===
  //         entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.handoverMemoNo = sectionMemoNo;
  //         entry.status_details.dateOfHandingOver = sectionDateOfHandingOver;
  //       }
  //       if (
  //         translatedText("release_on_court_order") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.courtOrderNo = sectionCourtOrderNo;
  //         entry.status_details.releasedToWhom = sectionReleased;
  //         entry.status_details.releseddate = sectionRelesedDate;
  //         entry.status_details.gdNo = sectionGdNo;
  //       }
  //       if (
  //         translatedText("destroyed_disposed") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.executiveOrder = sectionExecutiveOrderNo;
  //         entry.status_details.disposalDate = sectionDisposaldate;
  //         entry.status_details.auctionDate = sectionAuctionDate;
  //         entry.status_details.auctionOrderNo = sectionAuctionOrderNo;
  //         entry.status_details.awarded = sectionAawarded;
  //         entry.status_details.auctionMemoNo = sectionAuctionMemoNo;
  //       }
  //     });

  //     // Create FormData object and append entries and files
  //     const requestBody = new FormData();
  //     requestBody.append("entryData", JSON.stringify(entryData));

  //     if (attachmentFile && attachmentFile.length > 0) {
  //       for (const { file, type } of attachmentFile) {
  //         console.log(
  //           "Appending file:",
  //           file.name,
  //           "Size:",
  //           file.size,
  //           "Type:",
  //           type
  //         );
  //         requestBody.append("Attachment", file);
  //         requestBody.append("FileSize", file.size);
  //         requestBody.append("DocumentType", type);
  //       }
  //     }

  //     const response = await axios.post(`${API_URL}/api/data`, requestBody, {
  //       headers: {
  //         Authorization: authKey,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     const updatedData = [response.data];
  //     const formattedData = updatedData.map((entry) => ({
  //       ...entry,
  //       status_details: JSON.parse(entry.status_details || "{}"),
  //     }));

  //     setSnackbarMessage("Data inserted successfully!");
  //     setOpenSnackbar(true);
  //     await fetchUseData();

  //     setTimeout(() => {
  //       setOpenSnackbar(false);
  //       handleInsertPopupClose();
  //     }, 1000);
  //   } catch (error) {
  //     console.error(error);
  //     if (error.response && error.response.status === 401) {
  //       navigate("/signin");
  //     }
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  // const handleSubmit = async (e, index) => {
  //   e.preventDefault();
  //   let hasErrors = false;
  //   setIsSubmitting(true);

  //   // Validate form fields
  //   const updatedValidationErrors = {
  //     police_station: !entries[index].police_station,
  //     guna_number: !entries[index].guna_number,
  //     date_of_seizure: !entries[index].date_of_seizure,
  //     chart_sheet_date: !entries[index].chart_sheet_date,
  //     next_court_date: !entries[index].next_court_date,
  //     exhibit_number: !entries[index].exhibit_number,
  //     description: !entries[index].description,
  //     selectedAct: selectedOptions.length === 0,
  //     specifyAct:
  //       selectedOptions.some((option) => option.name === "Others Acts") &&
  //       !specifyAct.trim(),
  //     sectionOfLaws: selectedOptions.some(
  //       (option) => !sectionOfLaws[option.name]?.trim()
  //     ),
  //   };

  //   setValidationErrors(updatedValidationErrors);

  //   // Check if there are any validation errors
  //   for (const field in updatedValidationErrors) {
  //     if (updatedValidationErrors[field]) {
  //       hasErrors = true;
  //     }
  //   }

  //   if (hasErrors) {
  //     setIsSubmitting(false);
  //     setSnackbarMessage("Please fill in all required fields.");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   let selectedAct = "";
  //   if (selectedOptions.some((option) => option.name === "Others Acts")) {
  //     selectedAct = specifyAct.trim();
  //   } else {
  //     selectedAct = selectedOptions.map((option) => option.name).join(", ");
  //   }

  //   try {
  //     setIsSubmitting(true);

  //     const authKey = localStorage.getItem("authKey");
  //     const entryData = [...entries];

  //     entryData.forEach((entry, entryIndex) => {
  //       entry.status_details = entry.status_details || {};
  //       entry.selectedAct = selectedAct;
  //       entry.specifyAct = specifyAct;
  //       entry.unit = selectedUnit;
  //       selectedOptions.forEach((option) => {
  //         entry.sectionOfLaws = {
  //           ...entry.sectionOfLaws,
  //           [option.name]: sectionOfLaws[option.name] || "",
  //         };
  //       });
  //       entry.sectionMemoNo = sectionMemoNo;
  //       entry.status_details.cfslName = sectionCfslName;
  //       entry.status_details.sentBy = sectionSentBy;
  //       entry.status_details.other_status_case_property = sectionOtherStatus;
  //       entry.status_details.disposalOnCourt = selectedCourtOrderOption;
  //       entry.status_details.fslList = selectedOption;
  //       entry.status_details.paymentMode = selectedPaymentMethod;
  //       if (
  //         translatedText("handed_over_to_other_department") ===
  //         entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.handoverMemoNo = sectionMemoNo;
  //         entry.status_details.dateOfHandingOver = sectionDateOfHandingOver;
  //       }
  //       if (
  //         translatedText("release_on_court_order") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.courtOrderNo = sectionCourtOrderNo;
  //         entry.status_details.releasedToWhom = sectionReleased;
  //         entry.status_details.releseddate = sectionRelesedDate;
  //         entry.status_details.gdNo = sectionGdNo;
  //       }
  //       if (
  //         translatedText("destroyed_disposed") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.executiveOrder = sectionExecutiveOrderNo;
  //         entry.status_details.disposalDate = sectionDisposaldate;
  //         entry.status_details.auctionDate = sectionAuctionDate;
  //         entry.status_details.auctionOrderNo = sectionAuctionOrderNo;
  //         entry.status_details.awarded = sectionAawarded;
  //         entry.status_details.auctionMemoNo = sectionAuctionMemoNo;
  //       }
  //     });

  //     // Create FormData object and append entries and files
  //     const requestBody = new FormData();
  //     requestBody.append("entryData", JSON.stringify(entryData));

  //     if (attachmentFile && attachmentFile.length > 0) {
  //       for (const { file, type } of attachmentFile) {
  //         console.log(
  //           "Appending file:",
  //           file.name,
  //           "Size:",
  //           file.size,
  //           "Type:",
  //           type
  //         );
  //         requestBody.append("Attachment", file);
  //         requestBody.append("FileSize", file.size);
  //         requestBody.append("DocumentType", type);
  //       }
  //     }

  //     const response = await axios.post(`${API_URL}/api/data`, requestBody, {
  //       headers: {
  //         Authorization: authKey,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     const updatedData = [response.data];
  //     const formattedData = updatedData.map((entry) => ({
  //       ...entry,
  //       status_details: JSON.parse(entry.status_details || "{}"),
  //     }));

  //     setSnackbarMessage("Data inserted successfully!");
  //     setOpenSnackbar(true);
  //     await fetchUseData();

  //     setTimeout(() => {
  //       setOpenSnackbar(false);
  //       handleInsertPopupClose();
  //     }, 1000);
  //   } catch (error) {
  //     console.error(error);
  //     if (error.response && error.response.status === 401) {
  //       navigate("/signin");
  //     }
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  // const handleSubmit = async (e, index) => {
  //   e.preventDefault();
  //   let hasErrors = false;
  //   setIsSubmitting(true);

  //   // Validate form fields
  //   const updatedValidationErrors = {
  //     police_station: !entries[index].police_station,
  //     guna_number: !entries[index].guna_number,
  //     date_of_seizure: !entries[index].date_of_seizure,
  //     chart_sheet_date: !entries[index].chart_sheet_date,
  //     next_court_date: !entries[index].next_court_date,
  //     exhibit_number: !entries[index].exhibit_number,
  //     description: !entries[index].description,
  //     selectedAct: selectedOptions.length === 0,
  //     specifyAct:
  //       selectedOptions.some((option) => option.name === "Others Acts") &&
  //       !specifyAct.trim(),
  //     sectionOfLaws: selectedOptions.some(
  //       (option) => !sectionOfLaws[option.name]?.trim()
  //     ),
  //   };

  //   setValidationErrors(updatedValidationErrors);

  //   // Check if there are any validation errors
  //   for (const field in updatedValidationErrors) {
  //     if (updatedValidationErrors[field]) {
  //       hasErrors = true;
  //     }
  //   }

  //   if (hasErrors) {
  //     setIsSubmitting(false);
  //     setSnackbarMessage("Please fill in all required fields.");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   let selectedAct = "";
  //   if (selectedOptions.some((option) => option.name === "Others Acts")) {
  //     selectedAct = specifyAct.trim();
  //   } else {
  //     selectedAct = selectedOptions.map((option) => option.name).join(", ");
  //   }

  //   try {
  //     setIsSubmitting(true);

  //     const authKey = localStorage.getItem("authKey");
  //     const entryData = [...entries];

  //     entryData.forEach((entry, entryIndex) => {
  //       entry.status_details = entry.status_details || {};
  //       entry.selectedAct = selectedAct;
  //       entry.specifyAct = specifyAct;
  //       entry.unit = selectedUnit;
  //       selectedOptions.forEach((option) => {
  //         entry.sectionOfLaws = {
  //           ...entry.sectionOfLaws,
  //           [option.name]: sectionOfLaws[option.name] || "",
  //         };
  //       });
  //       entry.sectionMemoNo = sectionMemoNo;
  //       entry.status_details.cfslName = sectionCfslName;
  //       entry.status_details.sentBy = sectionSentBy;
  //       entry.status_details.other_status_case_property = sectionOtherStatus;
  //       entry.status_details.disposalOnCourt = selectedCourtOrderOption;
  //       entry.status_details.fslList = selectedOption;
  //       entry.status_details.paymentMode = selectedPaymentMethod;
  //       if (
  //         translatedText("handed_over_to_other_department") ===
  //         entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.handoverMemoNo = sectionMemoNo;
  //         entry.status_details.dateOfHandingOver = sectionDateOfHandingOver;
  //       }
  //       if (
  //         translatedText("release_on_court_order") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.courtOrderNo = sectionCourtOrderNo;
  //         entry.status_details.releasedToWhom = sectionReleased;
  //         entry.status_details.releseddate = sectionRelesedDate;
  //         entry.status_details.gdNo = sectionGdNo;
  //       }
  //       if (
  //         translatedText("destroyed_disposed") === entry.status_of_muddamaal
  //       ) {
  //         entry.status_details.executiveOrder = sectionExecutiveOrderNo;
  //         entry.status_details.disposalDate = sectionDisposaldate;
  //         entry.status_details.auctionDate = sectionAuctionDate;
  //         entry.status_details.auctionOrderNo = sectionAuctionOrderNo;
  //         entry.status_details.awarded = sectionAawarded;
  //         entry.status_details.auctionMemoNo = sectionAuctionMemoNo;
  //       }

  //       // Format chart_sheet_date and next_court_date to yyyy-mm-dd
  //       if (entry.chart_sheet_date) {
  //         entry.chart_sheet_date = new Date(entry.chart_sheet_date).toISOString().split('T')[0];
  //       }
  //       if (entry.next_court_date) {
  //         entry.next_court_date = new Date(entry.next_court_date).toISOString().split('T')[0];
  //       }
  //     });

  //     // Create FormData object and append entries and files
  //     const requestBody = new FormData();
  //     requestBody.append("entryData", JSON.stringify(entryData));

  //     if (attachmentFile && attachmentFile.length > 0) {
  //       for (const { file, type } of attachmentFile) {
  //         console.log(
  //           "Appending file:",
  //           file.name,
  //           "Size:",
  //           file.size,
  //           "Type:",
  //           type
  //         );
  //         requestBody.append("Attachment", file);
  //         requestBody.append("FileSize", file.size);
  //         requestBody.append("DocumentType", type);
  //       }
  //     }

  //     const response = await axios.post(`${API_URL}/api/data`, requestBody, {
  //       headers: {
  //         Authorization: authKey,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     const updatedData = [response.data];
  //     const formattedData = updatedData.map((entry) => ({
  //       ...entry,
  //       status_details: JSON.parse(entry.status_details || "{}"),
  //     }));

  //     setSnackbarMessage("Data inserted successfully!");
  //     setOpenSnackbar(true);
  //     await fetchUseData();

  //     setTimeout(() => {
  //       setOpenSnackbar(false);
  //       handleInsertPopupClose();
  //     }, 1000);
  //   } catch (error) {
  //     console.error(error);
  //     if (error.response && error.response.status === 401) {
  //       navigate("/signin");
  //     }
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleSubmit = async (e, index) => {
    e.preventDefault();
    let hasErrors = false;
    setIsSubmitting(true);
    const entryTypeErrors = buildEntryTypeValidationErrors(
      entries[index],
      entryTypes,
    );

    // Validate form fields
    const updatedValidationErrors = {
      police_station: !entries[index].police_station,
      entry_type: entryTypeErrors.entry_type,
      guna_number: entryTypeErrors.guna_number,
      receipt_number: entryTypeErrors.receipt_number,
      other_entry_type: entryTypeErrors.other_entry_type,
      date_of_seizure: !entries[index].date_of_seizure,
      exhibit_number: !entries[index].exhibit_number,
      description: !entries[index].description,
      selectedAct: selectedOptions.length === 0,
      specifyAct:
        selectedOptions.some((option) => isOtherActOption(option)) &&
        !specifyAct.trim(),
      sectionOfLaws: selectedOptions.some(
        (option) =>
          !getSectionOfLawValue(option.name, {
            isOther: isOtherActOption(option),
          })?.trim(),
      ),
    };

    setValidationErrors(updatedValidationErrors);

    // Check if there are any validation errors
    for (const field in updatedValidationErrors) {
      if (updatedValidationErrors[field]) {
        hasErrors = true;
      }
    }

    if (hasErrors) {
      setIsSubmitting(false);
      setSnackbarMessage("Please fill in all required fields.");
      setOpenSnackbar(true);
      return;
    }

    let selectedAct = "";
    if (selectedOptions.some((option) => isOtherActOption(option))) {
      selectedAct = specifyAct.trim();
    } else {
      selectedAct = selectedOptions.map((option) => option.name).join(", ");
    }

    try {
      setIsSubmitting(true);

      const authKey = localStorage.getItem("authKey");
      const entryData = entries.map((entry) => {
        const normalizedEntry = sanitizeRecordForEntryType(
          {
            ...entry,
            status_details: entry.status_details || {},
          },
          entryTypes,
        );

        normalizedEntry.selectedAct = selectedAct;
        normalizedEntry.specifyAct = specifyAct;
        normalizedEntry.unit = selectedUnit;
        selectedOptions.forEach((option) => {
          normalizedEntry.sectionOfLaws = {
            ...normalizedEntry.sectionOfLaws,
            [option.name]: sectionOfLaws[option.name] || "",
          };
        });
        normalizedEntry.sectionMemoNo = sectionMemoNo;
        normalizedEntry.status_details.cfslName = sectionCfslName;
        normalizedEntry.status_details.sentBy = sectionSentBy;
        normalizedEntry.status_details.other_status_case_property =
          sectionOtherStatus;
        normalizedEntry.status_details.disposalOnCourt =
          selectedCourtOrderOption;
        normalizedEntry.status_details.fslList = selectedOption;
        normalizedEntry.status_details.paymentMode = selectedPaymentMethod;

        if (
          translatedText("handed_over_to_other_department") ===
          normalizedEntry.status_of_muddamaal
        ) {
          normalizedEntry.status_details.handoverMemoNo = sectionMemoNo;
          normalizedEntry.status_details.dateOfHandingOver =
            sectionDateOfHandingOver;
        }
        if (
          translatedText("release_on_court_order") ===
          normalizedEntry.status_of_muddamaal
        ) {
          normalizedEntry.status_details.courtOrderNo = sectionCourtOrderNo;
          normalizedEntry.status_details.releasedToWhom = sectionReleased;
          normalizedEntry.status_details.releseddate = sectionRelesedDate;
          normalizedEntry.status_details.gdNo = sectionGdNo;
        }
        if (
          translatedText("destroyed_disposed") ===
          normalizedEntry.status_of_muddamaal
        ) {
          normalizedEntry.status_details.executiveOrder =
            sectionExecutiveOrderNo;
          normalizedEntry.status_details.disposalDate = sectionDisposaldate;
          normalizedEntry.status_details.auctionDate = sectionAuctionDate;
          normalizedEntry.status_details.auctionOrderNo = sectionAuctionOrderNo;
          normalizedEntry.status_details.awarded = sectionAawarded;
          normalizedEntry.status_details.auctionMemoNo = sectionAuctionMemoNo;
        }

        return normalizedEntry;
      });

      // Create FormData object and append entries and files
      const requestBody = new FormData();
      requestBody.append("entryData", JSON.stringify(entryData));

      if (attachmentFile && attachmentFile.length > 0) {
        for (const { file, type } of attachmentFile) {
          console.log(
            "Appending file:",
            file.name,
            "Size:",
            file.size,
            "Type:",
            type,
          );
          requestBody.append("Attachment", file);
          requestBody.append("FileSize", file.size);
          requestBody.append("DocumentType", type);
        }
      }

      const response = await axios.post(`${API_URL}/api/data`, requestBody, {
        headers: {
          Authorization: authKey,
          "Content-Type": "multipart/form-data",
        },
      });

      const updatedData = [response.data];
      const formattedData = updatedData.map((entry) => ({
        ...entry,
        status_details: JSON.parse(entry.status_details || "{}"),
      }));

      setSnackbarMessage("Data inserted successfully!");
      setOpenSnackbar(true);
      await fetchUseData();

      setTimeout(() => {
        setOpenSnackbar(false);
        handleInsertPopupClose();
      }, 1000);
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 401) {
        navigate("/signin");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleSubmit = async (e, index) => {
  //   e.preventDefault();
  //   let hasErrors = false;
  //   setIsSubmitting(true);

  //   // Validate form fields
  //   const updatedValidationErrors = {
  //     police_station: !entries[index].police_station,
  //     guna_number: !entries[index].guna_number,
  //     date_of_seizure: !entries[index].date_of_seizure,
  //     exhibit_number: !entries[index].exhibit_number,
  //     description: !entries[index].description,
  //     selectedAct: selectedOptions.length === 0,
  //     specifyAct:
  //       selectedOptions.some((option) => option.name === "Others Acts") &&
  //       !specifyAct.trim(),
  //     sectionOfLaws: selectedOptions.some(
  //       (option) => !sectionOfLaws[option.name]?.trim()
  //     ),
  //   };

  //   setValidationErrors(updatedValidationErrors);

  //   for (const field in updatedValidationErrors) {
  //     if (updatedValidationErrors[field]) {
  //       hasErrors = true;
  //     }
  //   }

  //   if (hasErrors) {
  //     setIsSubmitting(false);
  //     setSnackbarMessage("Please fill in all required fields.");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   let selectedAct = "";
  //   if (selectedOptions.some((option) => option.name === "Others Acts")) {
  //     selectedAct = specifyAct.trim();
  //   } else {
  //     selectedAct = selectedOptions.map((option) => option.name).join(", ");
  //   }

  //   try {
  //     setIsSubmitting(true);

  //     const authKey = localStorage.getItem("authKey");
  //     const entryData = [...entries];

  //     entryData.forEach((entry) => {

  //       const formatDateToUTC = (date) => {
  //         if (!date) return null;
  //         const d = new Date(date);
  //         const year = d.getFullYear();
  //         const month = String(d.getMonth() + 1).padStart(2, "0");
  //         const day = String(d.getDate()).padStart(2, "0");
  //         return `${year}-${month}-${day}`;
  //       };

  //       entry.date_of_seizure = formatDateToUTC(entry.date_of_seizure);
  //       entry.chart_sheet_date = formatDateToUTC(entry.chart_sheet_date);
  //       entry.next_court_date = formatDateToUTC(entry.next_court_date);

  //       entry.status_details = entry.status_details || {};
  //       entry.selectedAct = selectedAct;
  //       entry.specifyAct = specifyAct;
  //       entry.unit = selectedUnit;
  //       selectedOptions.forEach((option) => {
  //         entry.sectionOfLaws = {
  //           ...entry.sectionOfLaws,
  //           [option.name]: sectionOfLaws[option.name] || "",
  //         };
  //       });
  //     });

  //     console.log("Submitting payload:", entryData);

  //     const requestBody = new FormData();
  //     requestBody.append("entryData", JSON.stringify(entryData));

  //     if (attachmentFile && attachmentFile.length > 0) {
  //       for (const { file, type } of attachmentFile) {
  //         requestBody.append("Attachment", file);
  //         requestBody.append("FileSize", file.size);
  //         requestBody.append("DocumentType", type);
  //       }
  //     }

  //     const response = await axios.post(`${API_URL}/api/data`, requestBody, {
  //       headers: {
  //         Authorization: authKey,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     const updatedData = [response.data];
  //     const formattedData = updatedData.map((entry) => ({
  //       ...entry,
  //       status_details: JSON.parse(entry.status_details || "{}"),
  //     }));
  //     setSnackbarMessage("Data inserted successfully!");
  //     setOpenSnackbar(true);
  //     await fetchUseData();

  //     setTimeout(() => {
  //       setOpenSnackbar(false);
  //       handleInsertPopupClose(false);
  //     }, 1000);
  //   } catch (error) {
  //     console.error(error);
  //     if (error.response && error.response.status === 401) {
  //       navigate("/signin");
  //     }
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const insertRef = useRef(null);

  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity="success"
          onClose={handleSnackbarClose}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <div
        className="insert-data-popup new_data-form-popup new_data-form-popup--create"
        ref={insertRef}
      >
        <div className="popup-content data-box new_data-form-surface">
          <div className="heading-content new_data-form-heading">
            <div className="heading new_data-form-title">
              Add {translatedText("muddamaals")}{" "}
            </div>
            <div className="close-icon" onClick={handleInsertPopupClose}>
              <IoMdClose />
            </div>
          </div>
          <div className="insert-popup new_data-form-scroll">
            <div className="new_data-form-body">
              {entries.map((_entry, index) => (
                <div
                  key={index}
                  style={{ width: "100%" }}
                  className="insert-form new_data-form-card"
                >
                  {/* <div className="sub-more-button">
                <button
                  type="button"
                  className="sub-more"
                  onClick={handleSubEntry}
                >
                  <RxCross2  className="sub-icon" />
                </button>
                </div> */}
                  <div className="insert-form-content new_data-form-content">
                    <form className="new_data-form">
                      <div className="first-input-form-group new_data-form-grid">
                        {/* <div className="form-group">
                      <label htmlFor="guna_number">
                        <span className="text-danger">*</span>
                        {translatedText("guna_number")}:
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="guna_number"
                          id="guna_number"
                          className={`form-control ${validationErrors.guna_number ? "is-invalid" : ""
                            }`}
                          value={entries[index].guna_number}
                          onChange={(e) => handleChange(e, index)}
                          placeholder={translatedText(
                            "guna_number_placeholder"
                          )}
                          disabled={index !== 0 && isNewEntryAdded}
                        />

                      </div>
                      {validationErrors.guna_number && (
                        <div className="invalid-feedback">
                          {translatedText("guna_number_validation")}
                        </div>
                      )}
                    </div> */}

                        <EntryTypeFields
                          entryTypes={entryTypes}
                          selectedEntryType={entries[index].entry_type}
                          selectedLanguage={selectedLanguage}
                          value={entries[index]}
                          errors={validationErrors}
                          translatedText={translatedText}
                          onEntryTypeChange={(entryTypeCode) =>
                            handleEntryTypeChange(entryTypeCode, index)
                          }
                          onFieldChange={(fieldName, value) =>
                            handleEntryTypeFieldChange(fieldName, value, index)
                          }
                          idPrefix={`insert-entry-${index}`}
                          disableEntryTypeSelection={
                            index !== 0 && isNewEntryAdded
                          }
                          disableIdentifierInputs={
                            index !== 0 && isNewEntryAdded
                          }
                        />

                        <div className="form-group">
                          <label htmlFor="date_of_seizure">
                            <span className="text-danger">*</span>
                            {translatedText("date_of_seizure")}:
                          </label>
                          <br />
                          <div className="input-group">
                            <DatePicker
                              selected={entries[index].date_of_seizure}
                              onChange={(date) => handleDateChange(date, index)}
                              name="date_of_seizure"
                              id="date_of_seizure"
                              dateFormat="dd/MM/yyyy"
                              placeholderText={translatedText(
                                "date_of_seizure_placeholder",
                              )}
                              className={`form-control date-picker-input ${
                                validationErrors.date_of_seizure
                                  ? "is-invalid"
                                  : ""
                              }`}
                              isClearable
                              showYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                onClick={() => handleDateIconClick(index)}
                              >
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                          {validationErrors.date_of_seizure && (
                            <div className="invalid-feedbackss">
                              {translatedText("date_of_seizure_validation")}
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="exhibit_number">
                            <span className="text-danger">*</span>
                            {translatedText("exhibit_number")}:
                          </label>
                          <br />
                          <div className="input-group">
                            <input
                              type="text"
                              name="exhibit_number"
                              id="exhibit_number"
                              placeholder={translatedText(
                                "exhibit_number_placeholder",
                              )}
                              className={`form-control ${
                                validationErrors.exhibit_number
                                  ? "is-invalid"
                                  : ""
                              }`}
                              value={entries[index].exhibit_number}
                              onChange={(e) => handleChange(e, index)}
                              min="0"
                            />
                          </div>
                          {validationErrors.exhibit_number && (
                            <div className="invalid-feedback">
                              {translatedText("exhibit_number_validation")}
                            </div>
                          )}
                        </div>

                        {activeCasePropertyTypeOptions.length > 0 && (
                          <div className="form-group">
                            <label htmlFor="muddamaal_type">
                              <span className="text-danger">*</span>
                              {translatedText("muddamaal_type")}:
                            </label>
                            <br />
                            <div className="input-group">
                              <select
                                name="muddamaal_type"
                                id="muddamaal_type"
                                className="form-control"
                                value={entries[index].muddamaal_type}
                                onChange={(e) => handleChange(e, index)}
                              >
                                {(activeCasePropertyTypeOptions.some(
                                  (option) =>
                                    option.value ===
                                    entries[index].muddamaal_type,
                                )
                                  ? activeCasePropertyTypeOptions
                                  : [
                                      {
                                        label: entries[index].muddamaal_type,
                                        value: entries[index].muddamaal_type,
                                      },
                                      ...activeCasePropertyTypeOptions,
                                    ].filter((option) => option?.value)
                                ).map((option, optionIndex) => (
                                  <option
                                    key={option.id || optionIndex}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <div className="input-group-append">
                                <span className="input-group-text">
                                  <MdExpandMore />
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        {isVehicleCasePropertyType(
                          entries[index].muddamaal_type,
                          masterCasePropertyTypeOptions,
                        ) && (
                          <div className="form-group">
                            <label htmlFor="vehicle_reason">
                              {translatedText(
                                "reason_for_impounding_the_vehicle",
                              )}
                            </label>
                            <br />
                            <div className="input-group">
                              <select
                                name="vehicle_reason"
                                id="vehicle_reason"
                                className="form-control"
                                value={entries[index].vehicle_reason}
                                onChange={(e) => handleChange(e, index)}
                              >
                                {(masterVehicleReasonOptions.length > 0
                                  ? masterVehicleReasonOptions
                                  : entries[index].vehicle_reason
                                    ? [
                                        {
                                          label: entries[index].vehicle_reason,
                                          value: entries[index].vehicle_reason,
                                        },
                                      ]
                                    : []
                                ).map((option, optionIndex) => (
                                  <option
                                    key={option.id || optionIndex}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <div className="input-group-append">
                                <span className="input-group-text">
                                  <MdExpandMore />
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                        {(userState === "Andaman and Nicobar" ||
                          userState === "Maharashtra") &&
                          isOtherCasePropertyType(
                            entries[index].muddamaal_type,
                            masterCasePropertyTypeOptions,
                          ) && (
                            <div className="form-group">
                              <label htmlFor="other_case_property_name">
                                {translatedText("other_case_property")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="other_case_property_name"
                                  id="other_case_property_name"
                                  placeholder={translatedText(
                                    "enter_other_case_property",
                                  )}
                                  className={`form-control ${
                                    validationErrors.other_case_property_name
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={
                                    entries[index].other_case_property_name
                                  }
                                  onChange={(e) => handleChange(e, index)}
                                  min="0"
                                />
                              </div>
                            </div>
                          )}

                        <div className="form-group">
                          <label htmlFor="chart_sheet_date">
                            {/* <span className="text-danger">*</span> */}
                            {translatedText("chart_sheet_date")}:
                          </label>
                          <br />
                          <div className="input-group">
                            <DatePicker
                              // selected={
                              //   entries[index].chart_sheet_date
                              //     ? entries[index].chart_sheet_date // Apply formatDate here
                              //     : null
                              // }

                              selected={entries[index].chart_sheet_date}
                              onChange={(date) =>
                                handleChargeSheetDateChange(date, index)
                              }
                              name="chart_sheet_date"
                              id="chart_sheet_date"
                              dateFormat="dd/MM/yyyy"
                              placeholderText={translatedText(
                                "enter_chart_sheet_date",
                              )}
                              className="form-control date-picker-input"
                              isClearable
                              showYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                onClick={() => handleDateIconClick(index)}
                              >
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="next_court_date">
                            {/* <span className="text-danger">*</span> */}
                            {translatedText("next_court_date")}:
                          </label>
                          <br />
                          <div className="input-group">
                            <DatePicker
                              // selected={entries[index].next_court_date} // Target the correct field
                              // selected={
                              //   entries[index].next_court_date
                              //     ? new Date(entries[index].next_court_date) // Ensure it's a Date object
                              //     : null
                              // }

                              selected={entries[index].next_court_date}
                              onChange={(date) =>
                                handleNextCourtDate(date, index)
                              }
                              name="next_court_date"
                              id="next_court_date"
                              dateFormat="dd/MM/yyyy"
                              placeholderText={translatedText(
                                "enter_next_court_date",
                              )}
                              className="form-control date-picker-input"
                              isClearable
                              showYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                onClick={() => handleDateIconClick(index)}
                              >
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="unit">{translatedText("unit")}</label>
                          <br />
                          <div className="input-group">
                            <select
                              id="unit"
                              name="unit"
                              className="form-control"
                              value={selectedUnit}
                              onChange={handleUnitChange}
                            >
                              <option value="">
                                {translatedText("select_unit")}
                              </option>
                              {masterUnitOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <MdExpandMore />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="price-group">
                          <div className="form-groupss">
                            <label htmlFor="quantity">
                              {translatedText("quantity")}:
                            </label>
                            <br />
                            <div className="input-group">
                              <input
                                type="number"
                                name="quantity"
                                id="quantity"
                                placeholder={translatedText(
                                  "quantity_placeholder",
                                )}
                                className={`form-controlss ${
                                  validationErrors.quantity ? "is-invalid" : ""
                                }`}
                                value={entries[index].quantity}
                                onChange={(e) => handleChange(e, index)}
                                min="0"
                              />
                            </div>
                          </div>

                          <div className="form-groupss">
                            <label htmlFor="price">
                              {translatedText("price")}:
                            </label>
                            <br />
                            <div className="input-group">
                              <input
                                type="number"
                                name="price"
                                id="price"
                                placeholder={translatedText(
                                  "price_placeholder",
                                )}
                                className={`form-controlss ${
                                  validationErrors.price ? "is-invalid" : ""
                                }`}
                                value={entries[index].price}
                                onChange={(e) => handleChange(e, index)}
                                min="0"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group description-group">
                          <label htmlFor="description">
                            <span className="text-danger">*</span>
                            {translatedText("description")}:
                          </label>
                          <br />
                          <div className="input-group">
                            <textarea
                              name="description"
                              id="description"
                              placeholder={translatedText(
                                "description_placeholder",
                              )}
                              className={`desc-txt form-control ${
                                validationErrors.description ? "is-invalid" : ""
                              }`}
                              value={entries[index].description}
                              onChange={(e) => handleChange(e, index)}
                            />

                            <small className="word-count">
                              {descriptionWordCount} words
                            </small>
                          </div>
                          {validationErrors.description && (
                            <div className="invalid-feedback">
                              {translatedText("description_validation")}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* <div className="middle-input-form-group">
                    <div className="acts-group">
                      <div className="form-group">
                        <label htmlFor="selectedOptions">Acts</label>
                        <Multiselect
                          options={options}
                          selectedValues={selectedOptions}
                          onSelect={handleSelect}
                          onRemove={handleRemove}
                          displayValue="name"
                          style={{
                            chips: {
                              background: "#007bff",
                              color: "#fff",
                              fontSize: "14px",
                            },
                            searchBox: { border: "1px solid #D9E1FF" },
                            optionContainer: {
                              border: "1px solid #007bff",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          }}
                          placeholder="Select options"
                          closeIcon="cancel"
                          avoidHighlightFirstOption={true}
                          showCheckbox={true}
                          hidePlaceholder={false}
                          closeOnSelect={false}
                        />
                      </div>
                    </div>
                    {selectedOptions.some(
                      (option) => option.name === "Others Acts"
                    ) && (
                        <div className="form-group">
                          <label htmlFor="specifyAct">Specify Act</label>
                          <input
                            type="text"
                            name="specifyAct"
                            id="specifyAct"
                            className="form-control"
                            value={specifyAct}
                            onChange={(e) => setSpecifyAct(e.target.value)}
                            placeholder="Specify act"
                          />
                        </div>
                      )}
                    <div className="sub-middle-input-form-group actsu">
                      {selectedOptions.map((option) => (
                        <div key={option.id} className="form-group">
                          <label htmlFor={option.name} className="acts-lable">{option.name} </label>
                          <input
                            type="text"
                            name={option.name}
                            id={option.name}
                            className="form-control"
                            value={sectionOfLaws[option.name] || ""}
                            onChange={(e) =>
                              handleSectionOfLawChange(e, option.name)
                            }
                            placeholder={`Section of law for ${option.name}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div> */}
                      <div className="middle-input-form-group new_data-form-section">
                        <div className="acts-group">
                          <div className="form-group">
                            <label htmlFor="selectedOptions">
                              <span className="text-danger">*</span>
                              {translatedText("act")}
                            </label>
                            <Multiselect
                              options={filteredOptions}
                              selectedValues={selectedOptions}
                              onSelect={handleSelect}
                              className={`form-controlaaa ${
                                validationErrors.selectedAct ? "is-invalid" : ""
                              }`}
                              onRemove={handleRemove}
                              displayValue="name"
                              style={{
                                chips: {
                                  background: "#007bff",
                                  color: "#fff",
                                  fontSize: "14px",
                                },
                                searchBox: { border: "1px solid #D9E1FF" },
                                optionContainer: {
                                  border: "1px solid #007bff",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                },
                              }}
                              // placeholder="Select options"
                              placeholder={translatedText("select_option")}
                              closeIcon="cancel"
                              avoidHighlightFirstOption={true}
                              showCheckbox={true}
                              hidePlaceholder={false}
                              closeOnSelect={false}
                            />
                            {validationErrors.selectedAct && (
                              <div className="error">Please select acts.</div>
                            )}
                          </div>
                        </div>

                        <div className="sub-middle-input-form-group new_data-form-subgrid">
                          {selectedOptions.map(
                            (option) =>
                              !isOtherActOption(option) && (
                                <div key={option.id} className="form-group">
                                  <label htmlFor={option.name}>
                                    {" "}
                                    <span className="text-danger">*</span>
                                    {option.name}
                                  </label>
                                  <input
                                    type="text"
                                    name={option.name}
                                    id={option.name}
                                    className={`form-control ${
                                      validationErrors.sectionOfLaws
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    value={getSectionOfLawValue(option.name)}
                                    onChange={(e) =>
                                      handleSectionOfLawChange(e, option.name)
                                    }
                                    placeholder={`Section of law for ${option.name}`}
                                  />
                                  {validationErrors.sectionOfLaws &&
                                    !getSectionOfLawValue(option.name) && (
                                      <div className="error">
                                        Please fill in the section of law for{" "}
                                        {option.name}.
                                      </div>
                                    )}
                                </div>
                              ),
                          )}

                          {selectedOptions.some((option) =>
                            isOtherActOption(option),
                          ) && (
                            <div className="other-acts-group new_data-form-subgrid">
                              <div className="form-group">
                                <label htmlFor="specifyAct">
                                  <span className="text-danger">*</span>Specify
                                  Act
                                </label>
                                <input
                                  type="text"
                                  name="specifyAct"
                                  id="specifyAct"
                                  // className="form-control"
                                  className={`form-control ${
                                    validationErrors.setSpecifyAct
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={specifyAct}
                                  onChange={(e) =>
                                    setSpecifyAct(e.target.value)
                                  }
                                  placeholder="Specify act"
                                />
                                {validationErrors.specifyAct && (
                                  <div className="error">
                                    Please specify the act.
                                  </div>
                                )}
                              </div>
                              <div className="form-group">
                                <label htmlFor={otherActOptionName}>
                                  {otherActOptionName}
                                </label>
                                <input
                                  type="text"
                                  name={otherActOptionName}
                                  id={otherActOptionName}
                                  // className="form-control"
                                  className={`form-control ${
                                    validationErrors.sectionOfLaws
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={getSectionOfLawValue(
                                    otherActOptionName,
                                    {
                                      isOther: true,
                                    },
                                  )}
                                  onChange={(e) =>
                                    handleSectionOfLawChange(
                                      e,
                                      otherActOptionName,
                                    )
                                  }
                                  placeholder={`Section of law for ${otherActOptionName}`}
                                />
                                {validationErrors.sectionOfLaws &&
                                  !getSectionOfLawValue(otherActOptionName, {
                                    isOther: true,
                                  }) && (
                                    <div className="error">
                                      Please fill in the section of law for{" "}
                                      {otherActOptionName}.
                                    </div>
                                  )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="last-input-form-group">
                        <div className="form-group">
                          <label htmlFor="status_of_muddamaal">
                            {translatedText("status_of_muddamaal")}:
                          </label>
                          <br />
                          <div className="input-group">
                            <select
                              name="status_of_muddamaal"
                              id="status_of_muddamaal"
                              className="form-control"
                              value={
                                entries[index].status_of_muddamaal ===
                                "In Police Station Account"
                                  ? translatedText("police_station_account")
                                  : entries[index].status_of_muddamaal
                              }
                              onChange={(e) => handleChange(e, index)}
                            >
                              {(masterStatusOptions.length > 0
                                ? masterStatusOptions
                                : [
                                    {
                                      label: entries[index].status_of_muddamaal,
                                      value: entries[index].status_of_muddamaal,
                                    },
                                  ]
                              ).map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <MdExpandMore />
                              </span>
                            </div>
                          </div>
                        </div>

                        {translatedText("destroyed_disposed") ===
                        entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="disposalOnCourt">
                                {translatedText("disposal_on_court_order")}
                              </label>
                              <br />
                              <div className="input-group">
                                <select
                                  id="disposalOnCourt"
                                  value={selectedCourtOrderOption}
                                  onChange={handleDropdownCourtOrderChange}
                                  className="form-control"
                                >
                                  <option value="Disposed">Disposed</option>
                                  <option value="Auction">Auction</option>
                                </select>
                              </div>
                            </div>

                            {selectedCourtOrderOption === "Disposed" && (
                              <>
                                <div className="form-group">
                                  <label htmlFor="executiveOrder">
                                    {translatedText("order_no_for_deputed")}
                                  </label>

                                  <input
                                    type="number"
                                    name="executiveOrder"
                                    id="executiveOrder"
                                    className="form-control"
                                    value={sectionExecutiveOrderNo}
                                    onChange={(e) =>
                                      setSectionExecutiveOrderNo(e.target.value)
                                    }
                                    placeholder={translatedText(
                                      "enter_order_no_deputed",
                                    )}
                                  />
                                </div>
                                <div className="form-group">
                                  <label htmlFor="disposalDate">
                                    {translatedText("date_of_disposal")}
                                  </label>

                                  <input
                                    type="date"
                                    name="disposalDate"
                                    id="disposalDate"
                                    className="form-control"
                                    value={sectionDisposaldate}
                                    onChange={(e) =>
                                      setSectionsectionDisposaldate(
                                        e.target.value,
                                      )
                                    }
                                  />
                                </div>
                                <div className="form-group-attachment attach-new">
                                  <label htmlFor="Attachment">
                                    Attachment for disposal order
                                  </label>
                                  <div className="input-group-attachment">
                                    <button
                                      type="button"
                                      className="challan-btn"
                                      onClick={handleUploadButtonClick}
                                    >
                                      <FiUpload /> Upload File
                                    </button>
                                    <input
                                      type="file"
                                      ref={fileInputRef}
                                      style={{ display: "none" }}
                                      onChange={handleDisposalFileInputChange}
                                    />
                                    {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                                      <span
                                        className="inquiry-file-btn"
                                        onClick={handleIconClick}
                                      >
                                        <MdAttachFile className="inquiry-file-icon" />{" "}
                                        {`${selectedFiles.length}`}
                                      </span>
                                    )}
                                    {isPopupOpen && (
                                      <div className="attach-popup">
                                        <div className="attach-popup-contant">
                                          <div className="attachment-header">
                                            <div className="attachment-header-content">
                                              Attachments
                                            </div>
                                            <button
                                              className="fiile-close-btn"
                                              onClick={handleCloseAttachment}
                                            >
                                              <IoCloseOutline className="file-close-icon" />
                                            </button>
                                          </div>
                                          {selectedFiles.length > 0 && (
                                            <div className="attach-scrroll-body">
                                              {selectedFiles.map(
                                                (file, index) => (
                                                  <div
                                                    className="attach-popup-contant-body"
                                                    key={index}
                                                  >
                                                    <div className="attach-file-container">
                                                      <div className="attach-file-show">
                                                        <div className="text-attachment">
                                                          {file.name.length > 15
                                                            ? `${file.name.substring(
                                                                0,
                                                                15,
                                                              )}...`
                                                            : file.name}
                                                        </div>
                                                        <div className="text-attachment-file">
                                                          File Size:(
                                                          {(
                                                            file.size / 1024
                                                          ).toFixed(2)}{" "}
                                                          KB)
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="file-delete-btn"
                                                        onClick={() =>
                                                          handleDeleteFile(
                                                            index,
                                                          )
                                                        }
                                                      >
                                                        <span>
                                                          {" "}
                                                          <MdDeleteOutline className="file-delete-icon" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ),
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}

                            {selectedCourtOrderOption === "Auction" && (
                              <>
                                <div className="form-group">
                                  <label htmlFor="auctionDate">
                                    {translatedText("date_of_auction")}
                                  </label>
                                  <input
                                    type="date"
                                    name="auctionDate"
                                    id="auctionDate"
                                    className="form-control"
                                    value={sectionAuctionDate}
                                    onChange={(e) =>
                                      setSectionAuctionDate(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label htmlFor="auctionOrderNo">
                                    {translatedText("auction_order_no")}
                                  </label>
                                  <input
                                    type="number"
                                    name="auctionOrderNo"
                                    id="auctionOrderNo"
                                    className="form-control"
                                    value={sectionAuctionOrderNo}
                                    onChange={(e) =>
                                      setSectionAuctionOrderNo(e.target.value)
                                    }
                                    placeholder={translatedText(
                                      "enter_auction_order_no",
                                    )}
                                  />
                                </div>

                                <div className="form-group">
                                  <label htmlFor="awarded">
                                    {translatedText("awarded_to_whom")}
                                  </label>
                                  <input
                                    type="text"
                                    name="awarded"
                                    id="awarded"
                                    className="form-control"
                                    value={sectionAawarded}
                                    onChange={(e) =>
                                      setSectionAawarded(e.target.value)
                                    }
                                    placeholder={translatedText(
                                      "enter_awarded_recipient",
                                    )}
                                  />
                                </div>

                                <div className="form-group">
                                  <label htmlFor="paymentMode">
                                    {translatedText("payment_made_through")}
                                  </label>
                                  <div className="radio-input-option">
                                    <div className="radio-input">
                                      <input
                                        type="radio"
                                        id="bankDeposit"
                                        name="paymentMethod"
                                        className="form-group-controls"
                                        value="Bank Deposit"
                                        checked={
                                          selectedPaymentMethod ===
                                          "Bank Deposit"
                                        }
                                        onChange={() =>
                                          setSelectedPaymentMethod(
                                            "Bank Deposit",
                                          )
                                        }
                                      />
                                      <label htmlFor="bankDeposit">
                                        {translatedText("bank_deposit")}
                                      </label>
                                    </div>
                                    <div className="radio-input">
                                      <input
                                        type="radio"
                                        id="cheque"
                                        name="paymentMethod"
                                        value="Cheque"
                                        checked={
                                          selectedPaymentMethod === "Cheque"
                                        }
                                        onChange={() =>
                                          setSelectedPaymentMethod("Cheque")
                                        }
                                      />
                                      <label htmlFor="cheque">
                                        {translatedText("cheque")}
                                      </label>
                                    </div>
                                    <div className="radio-input">
                                      <input
                                        type="radio"
                                        id="challan"
                                        name="paymentMethod"
                                        value="Challan"
                                        checked={
                                          selectedPaymentMethod === "Challan"
                                        }
                                        onChange={() =>
                                          setSelectedPaymentMethod("Challan")
                                        }
                                      />
                                      <label htmlFor="challan">
                                        {translatedText("challan")}
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className="form-group">
                                  <label htmlFor="auctionMemoNo">
                                    {translatedText("handover_memo_no")}
                                  </label>
                                  <input
                                    type="number"
                                    name="auctionMemoNo"
                                    id="auctionMemoNo"
                                    className="form-control"
                                    value={sectionAuctionMemoNo}
                                    onChange={(e) =>
                                      setSectionAuctionMemoNo(e.target.value)
                                    }
                                    placeholder={translatedText(
                                      "enter_handover_memo_no",
                                    )}
                                  />
                                </div>

                                <div className="form-group-attachment attach-new">
                                  <label htmlFor="Attachment">
                                    Attachment for auction order
                                  </label>
                                  <div className="input-group-attachment">
                                    <button
                                      type="button"
                                      className="challan-btn"
                                      onClick={handleUploadButtonClick}
                                    >
                                      <FiUpload /> Upload File
                                    </button>
                                    <input
                                      type="file"
                                      ref={fileInputRef}
                                      style={{ display: "none" }}
                                      onChange={handleAuctionFileInputChange}
                                    />
                                    {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                                      <span
                                        className="inquiry-file-btn"
                                        onClick={handleIconClick}
                                      >
                                        <MdAttachFile className="inquiry-file-icon" />{" "}
                                        {`${selectedFiles.length}`}
                                      </span>
                                    )}
                                    {isPopupOpen && (
                                      <div className="attach-popup">
                                        <div className="attach-popup-contant">
                                          <div className="attachment-header">
                                            <div className="attachment-header-content">
                                              Attachments
                                            </div>
                                            <button
                                              className="fiile-close-btn"
                                              onClick={handleCloseAttachment}
                                            >
                                              <IoCloseOutline className="file-close-icon" />
                                            </button>
                                          </div>
                                          {selectedFiles.length > 0 && (
                                            <div className="attach-scrroll-body">
                                              {selectedFiles.map(
                                                (file, index) => (
                                                  <div
                                                    className="attach-popup-contant-body"
                                                    key={index}
                                                  >
                                                    <div className="attach-file-container">
                                                      <div className="attach-file-show">
                                                        <div className="text-attachment">
                                                          {file.name.length > 15
                                                            ? `${file.name.substring(
                                                                0,
                                                                15,
                                                              )}...`
                                                            : file.name}
                                                        </div>
                                                        <div className="text-attachment-file">
                                                          File Size:(
                                                          {(
                                                            file.size / 1024
                                                          ).toFixed(2)}{" "}
                                                          KB)
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="file-delete-btn"
                                                        onClick={() =>
                                                          handleDeleteFile(
                                                            index,
                                                          )
                                                        }
                                                      >
                                                        <span>
                                                          {" "}
                                                          <MdDeleteOutline className="file-delete-icon" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ),
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        ) : null}

                        {translatedText("other") ===
                        entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="other_status_case_property">
                                {translatedText("other_status_case_property")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="other_status_case_property"
                                  id="other_status_case_property"
                                  className="form-control"
                                  value={sectionOtherStatus}
                                  onChange={(e) =>
                                    setSectionOtherStatus(e.target.value)
                                  }
                                  placeholder={translatedText(
                                    "enter_other_status_case_property",
                                  )}
                                />
                              </div>
                            </div>
                          </>
                        ) : null}

                        {translatedText("release_on_court_order") ===
                        entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="courtOrderNo">
                                {translatedText("court_order_no")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="number"
                                  name="CourtOrderNo"
                                  id="CourtOrderNo"
                                  className="form-control"
                                  value={sectionCourtOrderNo}
                                  onChange={(e) =>
                                    setSectionCourtOrderNo(e.target.value)
                                  }
                                  placeholder={translatedText(
                                    "enter_court_order_no",
                                  )}
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="releasedToWhom">
                                {translatedText("released_to_whom")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="ReleasedToWhom"
                                  id="ReleasedToWhom"
                                  className="form-control"
                                  value={sectionReleased}
                                  onChange={(e) =>
                                    setSectionReleased(e.target.value)
                                  }
                                  placeholder={translatedText(
                                    "enter_releaser_name",
                                  )}
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="releseddate">
                                {translatedText("date_of_release")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="Releseddate"
                                  id="Releseddate"
                                  className="form-control"
                                  value={sectionRelesedDate}
                                  onChange={(e) =>
                                    setSectionRelesedDate(e.target.value)
                                  }
                                  placeholder={translatedText(
                                    "enter_date_of_release",
                                  )}
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="gdNo">
                                {translatedText("gd_entry_no")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="number"
                                  name="GdNo"
                                  id="GdNo"
                                  className="form-control"
                                  value={sectionGdNo}
                                  onChange={(e) =>
                                    setSectionGdNo(e.target.value)
                                  }
                                  placeholder={translatedText(
                                    "enter_gd_entry_no",
                                  )}
                                />
                              </div>
                            </div>
                            <div className="form-group-attachment attach-new">
                              <label htmlFor="Attachment">
                                Attachment for release on court order
                              </label>
                              <div className="input-group-attachment">
                                <button
                                  type="button"
                                  className="challan-btn"
                                  onClick={handleUploadButtonClick}
                                >
                                  <FiUpload /> Upload File
                                </button>
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  style={{ display: "none" }}
                                  onChange={handleCourtOrderFileInputChange}
                                />
                                {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                                  <span
                                    className="inquiry-file-btn"
                                    onClick={handleIconClick}
                                  >
                                    <MdAttachFile className="inquiry-file-icon" />{" "}
                                    {`${selectedFiles.length}`}
                                  </span>
                                )}
                                {isPopupOpen && (
                                  <div className="attach-popup">
                                    <div className="attach-popup-contant">
                                      <div className="attachment-header">
                                        <div className="attachment-header-content">
                                          Attachments
                                        </div>
                                        <button
                                          className="fiile-close-btn"
                                          onClick={handleCloseAttachment}
                                        >
                                          <IoCloseOutline className="file-close-icon" />
                                        </button>
                                      </div>
                                      {selectedFiles.length > 0 && (
                                        <div className="attach-scrroll-body">
                                          {selectedFiles.map((file, index) => (
                                            <div
                                              className="attach-popup-contant-body"
                                              key={index}
                                            >
                                              <div className="attach-file-container">
                                                <div className="attach-file-show">
                                                  <div className="text-attachment">
                                                    {file.name.length > 15
                                                      ? `${file.name.substring(
                                                          0,
                                                          15,
                                                        )}...`
                                                      : file.name}
                                                  </div>
                                                  <div className="text-attachment-file">
                                                    File Size:(
                                                    {(file.size / 1024).toFixed(
                                                      2,
                                                    )}{" "}
                                                    KB)
                                                  </div>
                                                </div>
                                                <div
                                                  className="file-delete-btn"
                                                  onClick={() =>
                                                    handleDeleteFile(index)
                                                  }
                                                >
                                                  <span>
                                                    {" "}
                                                    <MdDeleteOutline className="file-delete-icon" />
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        ) : null}
                        {/* 
                    {translatedText("comes_from_fsl") ===
                      entries[index].status_of_muddamaal ||
                      translatedText("released_in_fsl") ===
                      entries[index].status_of_muddamaal ? (
                      <>
                        <div className="form-group">
                          <label htmlFor="fslList">FSL List</label>
                          <br />
                          <div className="input-group">
                            <select
                              id="fslList"
                              value={selectedOption}
                              onChange={handleDropdownChange}
                            >
                              <option value="All CFSL">All CFSL</option>
                              <option value="FSL Port Blair">
                                FSL Port Blair
                              </option>
                            </select>
                          </div>
                        </div>
                      </>
                    ) : null} */}

                        {translatedText("comes_from_fsl") ===
                          entries[index].status_of_muddamaal ||
                        translatedText("released_in_fsl") ===
                          entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="fslList">FSL List</label>
                              <br />
                              <div className="input-group">
                                <select
                                  id="fslList"
                                  value={selectedOption}
                                  onChange={handleDropdownChange}
                                  className="form-control"
                                >
                                  {/* <option value="All CFSL">All CFSL</option> */}
                                  <option value="FSL Port Blair">
                                    FSL Port Blair
                                  </option>
                                  {userState === "Goa" && (
                                    <option value="FSL Verna">FSL Verna</option>
                                  )}
                                  <option value="CFSL Pune">CFSL Pune</option>
                                  <option value="CFSL Kolkata">
                                    CFSL Kolkata
                                  </option>
                                  <option value="CFSL Chandigarh">
                                    CFSL Chandigarh
                                  </option>
                                  <option value="CFSL Hyderabad">
                                    CFSL Hyderabad
                                  </option>
                                  <option value="CFSL Bhopal">
                                    CFSL Bhopal
                                  </option>
                                  <option value="CFSL Assam">CFSL Assam</option>
                                  <option value="CFSL Ahmedabad">
                                    CFSL Ahmedabad
                                  </option>
                                  <option value="CFSL Gandhinagar">
                                    CFSL Gandhinagar
                                  </option>
                                  <option value="Other">Other</option>
                                  {/* Add other options as needed */}
                                </select>
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <MdExpandMore />
                                  </span>
                                </div>
                              </div>
                            </div>
                            {selectedOption === "Other" && (
                              <div className="form-group">
                                <label htmlFor="cfslName">
                                  {translatedText("name_of_cfsl")}
                                </label>
                                <br />
                                <input
                                  type="text"
                                  id="cfslName"
                                  // value={cfslName}
                                  value={sectionCfslName}
                                  className="form-control"
                                  // onChange={handleCfslNameChange}
                                  onChange={(e) =>
                                    setSectionCfslName(e.target.value)
                                  }
                                  placeholder={translatedText(
                                    "enter_name_of_cfsl",
                                  )}
                                />
                              </div>
                            )}
                          </>
                        ) : null}

                        {translatedText("sent_to_ps_ccs") ===
                        entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="sentBy">
                                {translatedText("sent_by")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="sentBy"
                                  id="sentBy"
                                  className="form-control"
                                  value={sectionSentBy}
                                  onChange={(e) =>
                                    setSectionSentBy(e.target.value)
                                  }
                                  placeholder={translatedText("enter_sent_by")}
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="DateStatus1">
                                {translatedText("Date")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="DateStatus1"
                                  id="DateStatus1"
                                  className="form-control"
                                  value={entries[index].status_details.date}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "date")
                                  }
                                  required
                                />
                              </div>
                            </div>
                          </>
                        ) : null}

                        {translatedText("central_cold_storage") ===
                        entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="sentBy">
                                {translatedText("sent_by")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="sentBy"
                                  id="sentBy"
                                  className="form-control"
                                  value={sectionSentBy}
                                  onChange={(e) =>
                                    setSectionSentBy(e.target.value)
                                  }
                                  placeholder={translatedText("enter_sent_by")}
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="DateStatus1">
                                {translatedText("Date")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="DateStatus1"
                                  id="DateStatus1"
                                  className="form-control"
                                  value={entries[index].status_details.date}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "date")
                                  }
                                  required
                                />
                              </div>
                            </div>
                          </>
                        ) : null}

                        {translatedText("handed_over_to_other_department") ===
                        entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="MemoNo">
                                {translatedText("handover_memo_no")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="number"
                                  name="MemoNo"
                                  id="MemoNo"
                                  className="form-control"
                                  value={sectionMemoNo}
                                  onChange={(e) =>
                                    setSectionMemoNo(e.target.value)
                                  }
                                  placeholder={translatedText(
                                    "enter_handover_memo_no",
                                  )}
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="DateOfHandingOver">
                                {translatedText("date_of_handing_over")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="DateOfHandingOver"
                                  id="DateOfHandingOver"
                                  value={sectionDateOfHandingOver}
                                  onChange={(e) =>
                                    setSectionDateOfHandingOver(e.target.value)
                                  }
                                  className="form-control"
                                />
                              </div>
                            </div>
                            <div className="form-group-attachment attach-new">
                              <label htmlFor="Attachment">
                                Attachment for Handover memo
                              </label>
                              <div className="input-group-attachment">
                                <button
                                  type="button"
                                  className="challan-btn"
                                  onClick={handleUploadButtonClick}
                                >
                                  <FiUpload /> Upload File
                                </button>
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  style={{ display: "none" }}
                                  onChange={handleHandedOverFileInputChange}
                                />
                                {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                                  <span
                                    className="inquiry-file-btn"
                                    onClick={handleIconClick}
                                  >
                                    <MdAttachFile className="inquiry-file-icon" />{" "}
                                    {`${selectedFiles.length}`}
                                  </span>
                                )}
                                {isPopupOpen && (
                                  <div className="attach-popup">
                                    <div className="attach-popup-contant">
                                      <div className="attachment-header">
                                        <div className="attachment-header-content">
                                          Attachments
                                        </div>
                                        <button
                                          className="fiile-close-btn"
                                          onClick={handleCloseAttachment}
                                        >
                                          <IoCloseOutline className="file-close-icon" />
                                        </button>
                                      </div>
                                      {selectedFiles.length > 0 && (
                                        <div className="attach-scrroll-body">
                                          {selectedFiles.map((file, index) => (
                                            <div
                                              className="attach-popup-contant-body"
                                              key={index}
                                            >
                                              <div className="attach-file-container">
                                                <div className="attach-file-show">
                                                  <div className="text-attachment">
                                                    {file.name.length > 15
                                                      ? `${file.name.substring(
                                                          0,
                                                          15,
                                                        )}...`
                                                      : file.name}
                                                  </div>
                                                  <div className="text-attachment-file">
                                                    File Size:(
                                                    {(file.size / 1024).toFixed(
                                                      2,
                                                    )}{" "}
                                                    KB)
                                                  </div>
                                                </div>
                                                <div
                                                  className="file-delete-btn"
                                                  onClick={() =>
                                                    handleDeleteFile(index)
                                                  }
                                                >
                                                  <span>
                                                    {" "}
                                                    <MdDeleteOutline className="file-delete-icon" />
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        ) : null}

                        {translatedText("police_station_account") ===
                        entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="NameStatus1">
                                {translatedText("name_of_the_account_holder")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="NameStatus1"
                                  id="NameStatus1"
                                  className="form-control"
                                  placeholder={translatedText(
                                    "enter_the_name_of_the_borrower_form_the_p_O_station",
                                  )}
                                  value={entries[index].status_details.name}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "name")
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="DateStatus1">
                                {translatedText(
                                  "date_received_from_the_p_o_station",
                                )}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="DateStatus1"
                                  id="DateStatus1"
                                  className="form-control"
                                  value={entries[index].status_details.date}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "date")
                                  }
                                  required
                                />
                              </div>
                            </div>
                            {userState === "Gujarat" && (
                              <div className="form-group">
                                <label htmlFor="OrderStatus">
                                  {translatedText("malkhana_register_no")}
                                </label>
                                <br />
                                <div className="input-group">
                                  <input
                                    type="text"
                                    name="OrderStatus"
                                    id="OrderStatus"
                                    className="form-control"
                                    placeholder={translatedText(
                                      "enter_malkhana_nos",
                                    )}
                                    value={
                                      entries[index].status_details.order_no
                                    }
                                    onChange={(e) =>
                                      handleStatusDetailsChange(
                                        e,
                                        index,
                                        "order_no",
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <></>
                        )}

                        {translatedText("comes_from_fsl") ===
                          entries[index].status_of_muddamaal ||
                        translatedText("comes_from_court") ===
                          entries[index].status_of_muddamaal ||
                        translatedText("comes_from_bank") ===
                          entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="NameStatus1">
                                {translatedText("police_station_account") ===
                                entries[index].status_of_muddamaal
                                  ? translatedText("name_of_the_account_holder")
                                  : translatedText("comes_from_fsl") ===
                                      entries[index].status_of_muddamaal
                                    ? translatedText(
                                        "name_of_the_one_to_be_taken_from_FSL",
                                      )
                                    : translatedText("comes_from_court") ===
                                        entries[index].status_of_muddamaal
                                      ? translatedText(
                                          "name_of_the_person_be_summoned_from_the_court",
                                        )
                                      : translatedText("comes_from_bank") ===
                                          entries[index].status_of_muddamaal
                                        ? translatedText(
                                            "name_of_the_borrower_from_the_bank",
                                          )
                                        : "Name"}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="NameStatus1"
                                  id="NameStatus1"
                                  className="form-control"
                                  placeholder={
                                    translatedText("police_station_account") ===
                                    entries[index].status_of_muddamaal
                                      ? translatedText(
                                          "enter_the_name_of_the_borrower_form_the_p_O_station",
                                        )
                                      : translatedText("comes_from_fsl") ===
                                          entries[index].status_of_muddamaal
                                        ? translatedText(
                                            "enter_the_name_of_the_borrower_form_the_fsl",
                                          )
                                        : translatedText("comes_from_court") ===
                                            entries[index].status_of_muddamaal
                                          ? translatedText(
                                              "enter_the_name_of_the_borrower_form_the_court",
                                            )
                                          : translatedText(
                                                "comes_from_bank",
                                              ) ===
                                              entries[index].status_of_muddamaal
                                            ? translatedText(
                                                "enter_the_name_of_the_borrower_form_the_bank",
                                              )
                                            : "Name"
                                  }
                                  value={entries[index].status_details.name}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "name")
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="DateStatus1">
                                {translatedText("police_station_account") ===
                                entries[index].status_of_muddamaal
                                  ? translatedText(
                                      "date_received_from_the_p_o_station",
                                    )
                                  : translatedText("comes_from_fsl") ===
                                      entries[index].status_of_muddamaal
                                    ? translatedText(
                                        "date_received_from_the_fsl",
                                      )
                                    : translatedText("comes_from_court") ===
                                        entries[index].status_of_muddamaal
                                      ? translatedText(
                                          "date_received_from_the_court",
                                        )
                                      : translatedText("comes_from_bank") ===
                                          entries[index].status_of_muddamaal
                                        ? translatedText(
                                            "date_received_from_the_bank",
                                          )
                                        : "Name"}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="date"
                                  name="bankTrans"
                                  ng-model="orderAstro.paymentDate"
                                  id="bankTrans"
                                  className="form-control"
                                  value={entries[index].status_details.date}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "date")
                                  }
                                  ng-disabled="isDisabled"
                                  required
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="OrderStatus">
                                {translatedText("order_no")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="OrderStatus"
                                  id="OrderStatus"
                                  className="form-control"
                                  placeholder={translatedText("enter_order_no")}
                                  value={entries[index].status_details.order_no}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(
                                      e,
                                      index,
                                      "order_no",
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : null}

                        {userState === "Gujarat" &&
                          translatedText("returned") ===
                            entries[index].status_of_muddamaal && (
                            <>
                              <div className="form-group">
                                <label htmlFor="NameStatus2">
                                  {translatedText("returned") ===
                                  entries[index].status_of_muddamaal
                                    ? translatedText("name_of_the_returnee")
                                    : "Name"}
                                </label>
                                <br />
                                <div className="input-group">
                                  <input
                                    type="text"
                                    name="NameStatus2"
                                    id="NameStatus2"
                                    className="form-control"
                                    placeholder={
                                      translatedText("returned") ===
                                      entries[index].status_of_muddamaal
                                        ? translatedText(
                                            "enter_the_name_of_the_returnee",
                                          )
                                        : "Name"
                                    }
                                    value={entries[index].status_details.name}
                                    onChange={(e) =>
                                      handleStatusDetailsChange(
                                        e,
                                        index,
                                        "name",
                                      )
                                    }
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label htmlFor="DateStatus2">
                                  {translatedText("returned") ===
                                  entries[index].status_of_muddamaal
                                    ? translatedText("return_date")
                                    : "Date"}
                                </label>
                                <br />
                                <div className="input-group">
                                  <input
                                    type="date"
                                    name="DateStatus2"
                                    id="DateStatus2"
                                    className="form-control"
                                    value={entries[index].status_details.date}
                                    onChange={(e) =>
                                      handleStatusDetailsChange(
                                        e,
                                        index,
                                        "date",
                                      )
                                    }
                                    placeholder="DD/MM/YYYY"
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label htmlFor="SendStatus">
                                  {translatedText("order_no")}
                                </label>
                                <br />
                                <div className="input-group">
                                  <input
                                    type="text"
                                    name="SendStatus"
                                    id="SendStatus"
                                    className="form-control"
                                    placeholder={translatedText(
                                      "enter_order_no",
                                    )}
                                    value={
                                      entries[index].status_details.javak_no
                                    }
                                    onChange={(e) =>
                                      handleStatusDetailsChange(
                                        e,
                                        index,
                                        "javak_no",
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}

                        {translatedText("released_in_fsl") ===
                          entries[index].status_of_muddamaal ||
                        translatedText("pending_in_court") ===
                          entries[index].status_of_muddamaal ||
                        translatedText("deposited_in_bank") ===
                          entries[index].status_of_muddamaal ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="NameStatus2">
                                {translatedText("released_in_fsl") ===
                                entries[index].status_of_muddamaal
                                  ? translatedText("name_of_the_sender_in_fsl")
                                  : translatedText("pending_in_court") ===
                                      entries[index].status_of_muddamaal
                                    ? translatedText(
                                        "name_of_the_depositing_in_court",
                                      )
                                    : translatedText("deposited_in_bank") ===
                                        entries[index].status_of_muddamaal
                                      ? translatedText(
                                          "name_of_the_depositing_in_bank",
                                        )
                                      : "Name"}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="NameStatus2"
                                  id="NameStatus2"
                                  className="form-control"
                                  placeholder={
                                    translatedText("returned") ===
                                    entries[index].status_of_muddamaal
                                      ? translatedText(
                                          "enter_the_name_of_the_returnee",
                                        )
                                      : translatedText("released_in_fsl") ===
                                          entries[index].status_of_muddamaal
                                        ? translatedText(
                                            "enter_the_name_of_the_sender",
                                          )
                                        : translatedText("pending_in_court") ===
                                            entries[index].status_of_muddamaal
                                          ? translatedText(
                                              "enter_the_name_of_the_submiter_person_court",
                                            )
                                          : translatedText(
                                                "deposited_in_bank",
                                              ) ===
                                              entries[index].status_of_muddamaal
                                            ? translatedText(
                                                "enter_the_name_of_the_submiter_person_bank",
                                              )
                                            : "Name"
                                  }
                                  value={entries[index].status_details.name}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "name")
                                  }
                                />
                              </div>
                            </div>

                            <div className="form-group">
                              <label htmlFor="DateStatus2">
                                {translatedText("returned") ===
                                entries[index].status_of_muddamaal
                                  ? translatedText("return_date")
                                  : translatedText("released_in_fsl") ===
                                      entries[index].status_of_muddamaal
                                    ? translatedText("date_deposite_in_the_fsl")
                                    : translatedText("pending_in_court") ===
                                        entries[index].status_of_muddamaal
                                      ? translatedText(
                                          "date_deposite_in_the_court",
                                        )
                                      : translatedText("deposited_in_bank") ===
                                          entries[index].status_of_muddamaal
                                        ? translatedText(
                                            "date_deposite_in_the_bank",
                                          )
                                        : "Name"}
                              </label>
                              <br />
                              <div className="input-group">
                                {/* <input
                              type="date"
                              name="DateStatus2"
                              id="DateStatus2"
                              className="form-control"
                              value={entries[index].status_details.date}
                              onChange={(e) =>
                                handleStatusDetailsChange(e, index, "date")
                              }
                              placeholder="DD/MM/YYYY"
                            /> */}
                                <input
                                  type="date"
                                  name="bankTrans"
                                  ng-model="orderAstro.paymentDate"
                                  id="bankTrans"
                                  className="form-control"
                                  value={entries[index].status_details.date}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(e, index, "date")
                                  }
                                  ng-disabled="isDisabled"
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-group">
                              <label htmlFor="SendStatus">
                                {translatedText("order_no")}
                              </label>
                              <br />
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="SendStatus"
                                  id="SendStatus"
                                  className="form-control"
                                  placeholder={translatedText("enter_order_no")}
                                  value={entries[index].status_details.javak_no}
                                  onChange={(e) =>
                                    handleStatusDetailsChange(
                                      e,
                                      index,
                                      "javak_no",
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </form>
                    {/* <button
                  type="button"
                  className="btn add-more"
                  onClick={handleSubEntry}
                >
                  <RiSubtractFill />Entry
                </button> */}
                  </div>
                  <div className="sub-more-button">
                    <button
                      type="button"
                      className="sub-more"
                      onClick={handleSubEntry}
                    >
                      <RxCross2 className="sub-icon" />
                    </button>
                  </div>
                </div>
              ))}

              <div className="new_data-add-more-row">
                <button
                  type="button"
                  className="btn add-more new_data-add-more"
                  onClick={handleAddEntry}
                >
                  <RiAddLine /> Multiple Entry
                </button>
              </div>
            </div>
          </div>
          <div className="last-button new_data-form-footer">
            <div className="last-group new_data-form-actions">
              <button
                type="button"
                className="btn close-button"
                // onClick={togglePopup}
                onClick={handleInsertPopupClose}
              >
                Close
              </button>

              <button
                type="submit"
                className="btn  save-button"
                disabled={isSubmitting}
                onClick={(e) => handleSubmit(e, currentIndex)}
              >
                {isSubmitting ? "Submitting..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InsertData;
